// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Drawer Container */
.SideDrawer_drawer__8TBjj {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  padding: 24px;
  color: var(--color-text);
  background: var(--color-bg);
}

.SideDrawer_snapshotSummaryGrid__Ox2sQ {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  margin-bottom: 24px;
}

.SideDrawer_snapshotSummaryRowHalf__O6wZs {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  margin-bottom: 24px;
  align-items: stretch;
}

.SideDrawer_snapshotSummaryControls__FwOdk {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 16px;
}

.SideDrawer_snapshotColumn__pZD2C {
  min-width: 0;
}

.SideDrawer_snapshotColumn__pZD2C .SideDrawer_drawerHeader__5-7-c {
  height: 100%;
}

.SideDrawer_summaryColumn__Xqkyj {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.SideDrawer_summaryHeaderRow__7p3bC {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.SideDrawer_sectionTitle__co\\+zi {
  font-size: var(--font-size-title);
  font-weight: 600;
  color: var(--color-text-strong);
}

.SideDrawer_pillsRow__DKTLi {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.SideDrawer_summaryColumnStack__DceJj {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

@media (min-width: 1024px) {
  .SideDrawer_snapshotSummaryGrid__Ox2sQ {
    grid-template-columns: minmax(0, 3fr) minmax(0, 7fr);
    align-items: start;
  }

  .SideDrawer_snapshotSummaryRowHalf__O6wZs {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    align-items: stretch;
  }
}

/* Header Section */
.SideDrawer_drawerHeader__5-7-c {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 0;
  padding: 16px;
  background-color: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 12px;
}

.SideDrawer_drawerHeader__5-7-c h3 {
  margin: 0;
  font-size: var(--font-size-title);
  font-weight: 700;
  color: var(--color-text);
  letter-spacing: -0.02em;
}

.SideDrawer_drawerHeader__5-7-c p {
  margin: 8px 0 0;
  color: var(--color-text-muted);
  font-size: var(--font-size-body);
  line-height: 1.4;
}

.SideDrawer_snapshotCode__04rzW {
  margin-top: 6px;
  font-size: var(--font-size-label);
  color: var(--color-text-muted);
  font-weight: 600;
}

.SideDrawer_snapshotTicker__5JPSe {
  margin-top: 6px;
  font-size: var(--font-size-label);
  color: var(--color-text-muted);
}

.SideDrawer_snapshotTickerRow__9Neq6 {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.SideDrawer_snapshotTickerLabel__svSX1 {
  font-size: var(--font-size-label);
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 600;
}

.SideDrawer_snapshotTickerInput__TItQ\\+ {
  background: var(--color-bg-alt);
  border: 1px solid var(--color-border);
  color: var(--color-text);
  border-radius: 8px;
  padding: 8px 10px;
  font-size: var(--font-size-body);
  width: 100%;
  box-sizing: border-box;
}

.SideDrawer_snapshotTickerInline__ncTYn {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.SideDrawer_snapshotTickerDisplay__9vMj8 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-alt);
  font-size: var(--font-size-body);
  color: var(--color-text);
}

.SideDrawer_snapshotTickerEditButton__cwmeh {
  border: none;
  background: transparent;
  color: var(--color-text-muted);
  font-size: var(--font-size-body);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.SideDrawer_snapshotTickerEditButton__cwmeh:hover {
  color: var(--color-text);
}

.SideDrawer_drawerDate__KqZcj {
  font-size: var(--font-size-label);
  color: var(--color-text-muted);
  padding: 8px 16px;
  background-color: var(--color-bg-muted);
  border-radius: 9999px;
  border: 1px solid var(--color-border);
  white-space: nowrap;
  font-weight: 500;
}

/* Record Select Grid */
.SideDrawer_recordSelect__Sxx1X {
  margin-top: 12px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

.SideDrawer_snapshotControls__m1Pdl {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.SideDrawer_snapshotRow__cDgOd {
  display: block;
}

.SideDrawer_snapshotRowTwo__et-Xp,
.SideDrawer_snapshotRowThree__nNIrI {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

.SideDrawer_snapshotColumnStack__ZS4Ok {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  align-items: stretch;
}

.SideDrawer_selectFieldRow__-iYJH {
  display: flex;
  align-items: center;
  gap: 8px;
}

.SideDrawer_selectFieldRow__-iYJH select {
  flex: 1 1 auto;
  min-width: 0;
}

.SideDrawer_selectField__QrdqI {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.SideDrawer_selectField__QrdqI select {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.SideDrawer_reportDatePicker__8h4e7 {
  display: flex;
  gap: 8px;
}

.SideDrawer_reportDatePicker__8h4e7 select {
  flex: 1 1;
  min-width: 0;
}

.SideDrawer_inlineLabel__zxixH {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.SideDrawer_selectField__QrdqI select {
  border-radius: 10px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-card);
  color: var(--color-text);
  padding: 8px 12px;
  font-size: 0.85rem;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.SideDrawer_selectField__QrdqI select:hover {
  border-color: var(--color-text-muted);
}

.SideDrawer_selectField__QrdqI select:focus {
  outline: none;
  border-color: var(--color-accent);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
}

.SideDrawer_purchaserSelect__xhbnt {
  margin-top: 16px;
}

.SideDrawer_advancedDisclosure__zKus2 {
  margin-top: 12px;
  border-top: 1px solid var(--color-border);
  padding-top: 10px;
}

.SideDrawer_advancedSummary__ksqYK {
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--color-text-muted);
  list-style: none;
}

.SideDrawer_advancedSummary__ksqYK::-webkit-details-marker {
  display: none;
}

.SideDrawer_advancedPanel__i0kil {
  margin-top: 8px;
  font-size: 0.8rem;
  color: var(--color-text-muted);
}

@media (min-width: 768px) {
  .SideDrawer_recordSelect__Sxx1X {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .SideDrawer_snapshotRowTwo__et-Xp {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .SideDrawer_snapshotRowThree__nNIrI {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {
  .SideDrawer_recordSelect__Sxx1X {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .SideDrawer_snapshotRowTwo__et-Xp {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .SideDrawer_snapshotRowThree__nNIrI {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .SideDrawer_impactReportControls__AevBt {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    align-items: end;
  }
}

/* Tab List */
.SideDrawer_tabList__iBjSH {
  display: flex;
  gap: 8px;
  margin-top: 20px;
  padding: 4px;
  background: var(--color-bg-card);
  border-radius: 12px;
  border: 1px solid var(--color-border);
}

.SideDrawer_tabButton__rwjDB {
  flex: 1 1;
  border: none;
  background: transparent;
  color: var(--color-text-muted);
  font-size: 0.9rem;
  font-weight: 500;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.SideDrawer_tabButton__rwjDB:hover {
  color: var(--color-text);
  background: var(--color-bg-muted);
}

.SideDrawer_tabButtonActive__j80jC {
  background: var(--color-accent);
  color: white;
}

/* Summary Grid */
.SideDrawer_summaryGrid__SXo0H {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
}

.SideDrawer_summaryCard__khKfG {
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 16px;
  transition: border-color 0.2s, transform 0.2s;
}

.SideDrawer_summaryCard__khKfG:hover {
  border-color: var(--color-text-muted);
  transform: translateY(-2px);
}

.SideDrawer_summaryCard__khKfG span {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.SideDrawer_summaryCard__khKfG strong {
  display: block;
  margin-top: 8px;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--color-text);
}

/* Detail List */
.SideDrawer_detailList__wNb1N {
  margin-top: 16px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.SideDrawer_detailItem__kpg0r {
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 10px;
  padding: 12px;
}

.SideDrawer_detailItem__kpg0r dt {
  font-size: 0.7rem;
  font-weight: 500;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.SideDrawer_detailItem__kpg0r dd {
  margin: 6px 0 0;
  font-weight: 600;
  font-size: 1rem;
  color: var(--color-text);
}

/* Columns Section */
.SideDrawer_columnsSection__p-Icb {
  margin-top: 24px;
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  padding: 20px;
}

.SideDrawer_columnsHeader__rt4ds {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--color-border);
}

.SideDrawer_columnsHeader__rt4ds h4 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--color-text);
}

.SideDrawer_columnsHeader__rt4ds p {
  margin: 0;
  font-size: 0.75rem;
  color: var(--color-text-muted);
}

.SideDrawer_columnGroups__dZDTq {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 16px;
}

.SideDrawer_columnGroup__XNRuD strong {
  display: block;
  margin-bottom: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--color-accent);
}

.SideDrawer_columnGroup__XNRuD ul {
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 0.8rem;
  color: var(--color-text-muted);
}

.SideDrawer_columnGroup__XNRuD li {
  margin-bottom: 6px;
  padding-left: 12px;
  position: relative;
}

.SideDrawer_columnGroup__XNRuD li::before {
  content: '•';
  position: absolute;
  left: 0;
  color: var(--color-border);
}

/* Purchaser Table */
.SideDrawer_purchaserTableWrap__77sCI {
  margin-top: 24px;
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  padding: 20px;
}

.SideDrawer_purchaserTableWrap__77sCI h4 {
  margin: 0 0 16px;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--color-text);
}

.SideDrawer_tableScroller__rpyy7 {
  overflow: visible;
  max-height: none;
  margin-top: 8px;
}

.SideDrawer_purchaserTable__R-yhm {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.SideDrawer_purchaserTable__R-yhm th,
.SideDrawer_purchaserTable__R-yhm td {
  border-bottom: 1px solid var(--color-border);
  padding: 12px 10px;
  text-align: left;
}

.SideDrawer_purchaserTable__R-yhm th {
  font-size: 0.7rem;
  font-weight: 600;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: var(--color-bg-muted);
  position: sticky;
  top: 0;
}

.SideDrawer_purchaserTable__R-yhm td {
  color: var(--color-text);
}

.SideDrawer_purchaserTable__R-yhm tbody tr:hover {
  background: var(--color-bg-muted);
}

.SideDrawer_purchaserTable__R-yhm tbody tr:last-child td {
  border-bottom: none;
}

.SideDrawer_changeCell__zkYXI {
  font-weight: 600;
}

/* Chart Headings */
.SideDrawer_chartHeading__7eQsc {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 12px;
  font-size: 0.9rem;
  color: var(--color-text-muted);
}

.SideDrawer_chartHeading__7eQsc span {
  font-size: 0.8rem;
  color: var(--color-accent);
}

/* Trend Heading */
.SideDrawer_trendHeading__m74LF {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin: 8px 0 12px;
  color: var(--color-text);
}

.SideDrawer_trendHeadingLeft__dcD4W {
  display: flex;
  align-items: center;
  gap: 10px;
}

.SideDrawer_trendViewLabel__ah4eZ {
  font-size: 0.7rem;
  color: var(--color-accent);
  border: 1px solid var(--color-accent);
  border-radius: 999px;
  padding: 4px 12px;
  text-transform: none;
  white-space: nowrap;
  background: rgba(99, 102, 241, 0.1);
}

.SideDrawer_trendHeadingMeta__aMSkr {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-left: auto;
}

.SideDrawer_regimeBadgeGroup__\\+EE7P {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.SideDrawer_regimeBadge__-iUpd {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-card);
  color: var(--color-text);
  font-size: 0.7rem;
  font-weight: 600;
  padding: 4px 10px;
  cursor: help;
}

.SideDrawer_regimeTooltip__NPDTI {
  position: absolute;
  top: 26px;
  right: 0;
  width: 260px;
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 12px;
  color: var(--color-text);
  font-size: 0.75rem;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-4px);
  transition: opacity 120ms ease-out, transform 120ms ease-out;
  z-index: 100;
  line-height: 1.4;
  text-align: left;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.SideDrawer_regimeTooltipList__XY4s\\+ {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.SideDrawer_regimeTooltipItem__aMuqY {
  position: relative;
  padding-left: 14px;
  color: var(--color-text-muted);
}

.SideDrawer_regimeTooltipItem__aMuqY::before {
  content: '•';
  position: absolute;
  left: 0;
  color: var(--color-accent);
}

.SideDrawer_regimeBadge__-iUpd:hover .SideDrawer_regimeTooltip__NPDTI,
.SideDrawer_regimeBadge__-iUpd:focus-visible .SideDrawer_regimeTooltip__NPDTI {
  opacity: 1;
  transform: translateY(0);
}

.SideDrawer_grossBadge__hldU4 {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-card);
  color: var(--color-text);
  font-size: 0.7rem;
  font-weight: 500;
  padding: 4px 10px;
  cursor: help;
}

.SideDrawer_grossBadgeElevated__Ls5kc {
  color: var(--color-warning);
  border-color: var(--color-warning);
}

.SideDrawer_grossBadgeLow__oi\\+1b {
  color: var(--color-success);
  border-color: var(--color-success);
}

.SideDrawer_grossBadgeNormal__4gf8i {
  color: var(--color-text-muted);
}

.SideDrawer_grossTooltip__FsJem {
  position: absolute;
  top: 26px;
  right: 0;
  width: 280px;
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 12px;
  color: var(--color-text);
  font-size: 0.75rem;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-4px);
  transition: opacity 120ms ease-out, transform 120ms ease-out;
  z-index: 100;
  line-height: 1.4;
  text-align: left;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.SideDrawer_grossTooltipLine__K26o- {
  display: block;
  margin-bottom: 6px;
  color: var(--color-text-muted);
}

.SideDrawer_grossTooltipNote__AQGVU {
  display: block;
  margin-top: 6px;
  color: var(--color-warning);
  font-weight: 600;
}

.SideDrawer_grossBadge__hldU4:hover .SideDrawer_grossTooltip__FsJem,
.SideDrawer_grossBadge__hldU4:focus-visible .SideDrawer_grossTooltip__FsJem {
  opacity: 1;
  transform: translateY(0);
}

.SideDrawer_signalsTourLink__W7uoc {
  background: transparent;
  border: none;
  color: var(--color-accent);
  font-size: var(--font-size-label);
  cursor: pointer;
  padding: 0;
  white-space: nowrap;
  text-decoration: underline;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.SideDrawer_signalsTourLinkLeft__tq43I {
  margin-right: auto;
}

.SideDrawer_signalsTourLink__W7uoc:hover {
  opacity: 0.8;
}

/* Regime Help Icon */
.SideDrawer_regimeHelpIcon__jX7cA {
  position: relative;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid var(--color-border);
  background: var(--color-bg-card);
  color: var(--color-accent);
  font-size: 0.7rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: help;
}

.SideDrawer_regimeHelpTooltip__wXuhl {
  position: absolute;
  top: 26px;
  right: 0;
  width: 280px;
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 12px;
  color: var(--color-text);
  font-size: 0.75rem;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-4px);
  transition: opacity 120ms ease-out, transform 120ms ease-out;
  z-index: 100;
  text-align: left;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.SideDrawer_regimeHelpTitle__P25oU {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--color-text);
}

.SideDrawer_regimeHelpList__ql572 {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.SideDrawer_regimeHelpItem__-H\\+1a {
  position: relative;
  padding-left: 14px;
  line-height: 1.4;
  color: var(--color-text-muted);
}

.SideDrawer_regimeHelpItem__-H\\+1a::before {
  content: '•';
  position: absolute;
  left: 0;
  color: var(--color-accent);
}

.SideDrawer_regimeHelpIcon__jX7cA:hover .SideDrawer_regimeHelpTooltip__wXuhl,
.SideDrawer_regimeHelpIcon__jX7cA:focus-visible .SideDrawer_regimeHelpTooltip__wXuhl {
  opacity: 1;
  transform: translateY(0);
}

/* Price Reference Control */
.SideDrawer_priceReferenceControl__oXDQs {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.75rem;
  color: var(--color-text-muted);
}

.SideDrawer_priceReferenceLabel__yW7Dg {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.7rem;
  color: var(--color-text-muted);
  white-space: nowrap;
}

.SideDrawer_priceReferenceInfoIcon__sRsQv {
  position: relative;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid var(--color-border);
  background: var(--color-bg-card);
  color: var(--color-accent);
  font-size: 0.7rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: help;
}

.SideDrawer_priceReferenceTooltip__fk\\+R2 {
  position: absolute;
  top: 26px;
  right: 0;
  width: 280px;
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 12px;
  color: var(--color-text);
  font-size: 0.75rem;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-4px);
  transition: opacity 120ms ease-out, transform 120ms ease-out;
  z-index: 100;
  line-height: 1.4;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.SideDrawer_priceReferenceInfoIcon__sRsQv:hover .SideDrawer_priceReferenceTooltip__fk\\+R2,
.SideDrawer_priceReferenceInfoIcon__sRsQv:focus-visible .SideDrawer_priceReferenceTooltip__fk\\+R2 {
  opacity: 1;
  transform: translateY(0);
}

.SideDrawer_priceReferenceSelect__cbUMR {
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  color: var(--color-text);
  border-radius: 8px;
  padding: 4px 10px;
  font-size: 0.75rem;
  transition: border-color 0.2s;
}

.SideDrawer_priceReferenceSelect__cbUMR:hover {
  border-color: var(--color-text-muted);
}

.SideDrawer_readinessBadge__B0k0z {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border-radius: 999px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-card);
  color: var(--color-text);
  font-size: 0.75rem;
  font-weight: 600;
  padding: 6px 12px;
  position: relative;
}

.SideDrawer_readinessInfoIcon__PJGiq {
  position: relative;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid var(--color-border);
  background: var(--color-bg-card);
  color: var(--color-text-muted);
  font-size: 0.7rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: help;
}

.SideDrawer_readinessTooltip__wmwAl {
  position: absolute;
  top: 0;
  left: 26px;
  width: min(40vw, 520px);
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  padding: 12px;
  color: var(--color-text);
  font-size: 0.75rem;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-4px);
  transition: opacity 120ms ease-out, transform 120ms ease-out;
  z-index: 120;
  line-height: 1.4;
  text-align: left;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.SideDrawer_readinessInfoIcon__PJGiq:hover .SideDrawer_readinessTooltip__wmwAl,
.SideDrawer_readinessInfoIcon__PJGiq:focus-visible .SideDrawer_readinessTooltip__wmwAl {
  opacity: 1;
  transform: translateY(0);
}

.SideDrawer_readinessTooltipTitle__Jpn6E {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--color-text);
}

.SideDrawer_readinessTooltipRowGrid__Do0Cz {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 8px;
}

.SideDrawer_readinessTooltipSection__n4yA9 {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.SideDrawer_readinessTooltipRow__RgbNQ {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  color: var(--color-text-muted);
}

.SideDrawer_readinessTooltipLabel__gWZLK {
  color: var(--color-text);
  font-weight: 500;
}

.SideDrawer_trendHeading__m74LF h4,
.SideDrawer_trendHeading__m74LF span {
  color: var(--color-text);
}

.SideDrawer_trendTooltip__YgDao {
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 10px 12px;
  color: var(--color-text);
  font-size: 0.75rem;
  line-height: 1.4;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.SideDrawer_trendTooltipLabel__Hp3oh {
  font-weight: 600;
  color: var(--color-text);
}

.SideDrawer_trendTooltipPrice__-FC8B {
  margin-top: 4px;
  color: var(--color-text-muted);
}

.SideDrawer_trendTooltipOi__tVJ7Q {
  margin-top: 4px;
  color: var(--color-text-muted);
}

.SideDrawer_trendTooltipInsight__qh-Jc {
  margin-top: 6px;
  color: var(--color-accent);
  font-weight: 600;
}

.SideDrawer_trendTooltipDetails__xNEfD {
  margin-top: 6px;
  color: var(--color-text-muted);
}

.SideDrawer_trendRange__nJo8o {
  color: var(--color-text);
  font-size: 0.9rem;
  font-weight: 600;
  text-align: right;
}

/* CFTC Trend Tooltip (Landing page style guide alignment) */
.SideDrawer_cftcTooltipCard__ZrSxm {
  width: 440px;
  max-width: 90vw;
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  padding: 16px;
  color: var(--color-text);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.SideDrawer_cftcTooltipHeader__5h8ho {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.SideDrawer_cftcTooltipTitle__kEfJN {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--color-text);
}

.SideDrawer_cftcTooltipBadge__kfGvj {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-muted);
  padding: 4px 10px;
  font-size: 0.6rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-text-strong);
}

.SideDrawer_cftcTooltipMeta__WjZ-z {
  margin-top: 6px;
  font-size: 0.75rem;
  color: var(--color-text-muted);
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.SideDrawer_cftcTooltipDesk__dmRNp {
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-muted);
}

.SideDrawer_cftcTooltipDeskLabel__8ikXC {
  font-size: 0.6rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--color-text-muted);
}

.SideDrawer_cftcTooltipDeskBody__Tu6eK {
  margin-top: 6px;
  border-left: 2px solid var(--color-accent);
  padding-left: 10px;
  font-size: 0.75rem;
  color: var(--color-text-strong);
  line-height: 1.4;
}

.SideDrawer_cftcTooltipActors__Cp1jl {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.SideDrawer_cftcTooltipActor__eXCiy {
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-muted);
}

.SideDrawer_cftcTooltipActorRow__Nji2Z {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.SideDrawer_cftcTooltipActorLabel__EgtMQ {
  font-size: 0.85rem;
  font-weight: 600;
}

.SideDrawer_cftcTooltipActorMeta__ArPG0 {
  margin-top: 4px;
  font-size: 0.7rem;
  color: var(--color-text-muted);
}

.SideDrawer_cftcTooltipActorRight__ROcNr {
  text-align: right;
}

.SideDrawer_cftcTooltipActorNet__qGLUw {
  font-size: 0.85rem;
  font-weight: 600;
}

/* Alerts Button & Panel */
.SideDrawer_alertsButton__K--e9 {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 999px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-card);
  color: var(--color-text);
  font-size: 0.75rem;
  font-weight: 500;
  padding: 6px 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.SideDrawer_alertsButton__K--e9:hover {
  border-color: var(--color-accent);
  background: var(--color-bg-muted);
}

.SideDrawer_alertsCount__egqFQ {
  background: var(--color-accent);
  color: white;
  border-radius: 999px;
  padding: 2px 8px;
  font-size: var(--font-size-tiny);
  font-weight: 600;
}

.SideDrawer_summaryMuted__o2Ha0 {
  font-size: var(--font-size-caption);
  color: var(--color-text-muted);
}

.SideDrawer_summaryStrong__MHoWx {
  font-size: var(--font-size-body);
  font-weight: 600;
  color: var(--color-text-strong);
}

.SideDrawer_summaryText__iUp\\+E {
  font-size: var(--font-size-body);
  color: var(--color-text-muted);
}

.SideDrawer_summaryBanner__2ewMQ {
  border: 1px solid var(--color-border);
  border-radius: 12px;
  background: var(--color-bg-muted);
  padding: 8px;
  font-size: var(--font-size-caption);
  color: var(--color-text-muted);
}

.SideDrawer_summaryWarning__1JMes {
  color: var(--color-warning);
}

.SideDrawer_panelCard__ipLKI {
  border: 1px solid var(--color-border);
  border-radius: 16px;
  background: var(--color-bg-panel);
  padding: 24px;
}

.SideDrawer_panelTitle__tFRec {
  font-size: var(--font-size-label);
  font-weight: 600;
  color: var(--color-text-strong);
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.SideDrawer_panelTitleSmall__8zse8 {
  font-size: var(--font-size-body);
  font-weight: 600;
  color: var(--color-text-strong);
  margin-bottom: 8px;
}

.SideDrawer_panelBody__gFt3O {
  margin-top: 12px;
}

.SideDrawer_impactReportControls__AevBt {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  margin-bottom: 12px;
}

.SideDrawer_impactReportGenerateCol__NIDko {
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: flex-end;
}

.SideDrawer_impactReportGenerateButton__VD33n {
  border: 1px solid var(--color-accent);
  background: var(--color-accent);
  color: #fff;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: var(--font-size-body);
  font-weight: 600;
  cursor: pointer;
}

.SideDrawer_impactReportGenerateButton__VD33n:hover {
  opacity: 0.92;
}

.SideDrawer_impactReportGroupGrid__kLcG8 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 8px;
  margin-bottom: 12px;
}

.SideDrawer_impactReportGroupOption__KQtjW {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--color-border);
  border-radius: 10px;
  padding: 8px 10px;
  background: var(--color-bg-muted);
  color: var(--color-text);
  font-size: var(--font-size-body);
}

.SideDrawer_impactReportGroupOption__KQtjW input {
  accent-color: var(--color-accent);
}

.SideDrawer_impactReportSummary__bwmbs {
  border: 1px solid var(--color-border);
  border-radius: 12px;
  background: var(--color-bg-muted);
  padding: 12px;
  margin-bottom: 12px;
}

.SideDrawer_impactReportSection__ywj0x {
  margin-bottom: 12px;
}

.SideDrawer_impactReportList__tLbEo {
  margin: 0;
  padding-left: 18px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: var(--font-size-body);
  color: var(--color-text-muted);
}

.SideDrawer_impactRiskBadge__vfRCI {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  padding: 3px 10px;
  font-size: var(--font-size-caption);
  font-weight: 600;
  border: 1px solid var(--color-border);
}

.SideDrawer_impactRiskHigh__Js5a1 {
  color: var(--color-danger);
  border-color: var(--color-danger);
}

.SideDrawer_impactRiskModerate__07JQh {
  color: var(--color-warning);
  border-color: var(--color-warning);
}

.SideDrawer_impactRiskLow__E1qZP {
  color: var(--color-success);
  border-color: var(--color-success);
}

.SideDrawer_snapshotDonutWrap__Zjk6i {
  margin-bottom: 16px;
  min-height: 260px;
}

.SideDrawer_snapshotDonutGrid__RryEw {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  align-items: stretch;
}

.SideDrawer_snapshotDonutCard__BZRG- {
  padding: 12px;
  border-radius: 12px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-panel);
  height: 100%;
  min-height: 240px;
}

.SideDrawer_snapshotDonutCard__BZRG- .js-plotly-plot,
.SideDrawer_snapshotDonutCard__BZRG- .plot-container,
.SideDrawer_snapshotDonutCard__BZRG- .svg-container {
  height: 100% !important;
}

.SideDrawer_snapshotDonutCard__BZRG- .slice text,
.SideDrawer_snapshotDonutCard__BZRG- .legend text,
.SideDrawer_snapshotDonutCard__BZRG- .gtitle,
.SideDrawer_snapshotDonutCard__BZRG- .infolayer text {
  font-weight: 700;
}

.SideDrawer_snapshotDonutLabel__gECM2 {
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-strong);
  margin-bottom: 6px;
}

.SideDrawer_snapshotChartHeader__Wu6k4 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.SideDrawer_snapshotChartTitle__zEkTc {
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-strong);
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.SideDrawer_snapshotChangeCharts__bOeZf {
  margin-bottom: 16px;
  padding-bottom: 12px;
}

.SideDrawer_snapshotChangeGrid__4XAm8 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
}

.SideDrawer_snapshotChangeCard__6S86m {
  padding: 12px;
  border-radius: 12px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-panel);
  height: 100%;
  min-height: 260px;
  display: flex;
  flex-direction: column;
}

.SideDrawer_snapshotChangeTitle__lAGPV {
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-strong);
  margin-bottom: 6px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.SideDrawer_snapshotChangeCard__6S86m .js-plotly-plot,
.SideDrawer_snapshotChangeCard__6S86m .plot-container,
.SideDrawer_snapshotChangeCard__6S86m .svg-container {
  height: 100% !important;
}

.SideDrawer_snapshotPieWrap__xxfih {
  margin-top: 16px;
}

.SideDrawer_snapshotPieGrid__e3poe {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

.SideDrawer_snapshotPieCard__3uDpW {
  padding: 12px;
  border-radius: 12px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-panel);
  height: 100%;
  min-height: 220px;
  display: flex;
  flex-direction: column;
}

.SideDrawer_snapshotPieCard__3uDpW .js-plotly-plot,
.SideDrawer_snapshotPieCard__3uDpW .plot-container,
.SideDrawer_snapshotPieCard__3uDpW .svg-container {
  height: 100% !important;
}

.SideDrawer_snapshotPieRow__SGagc {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 12px;
  align-items: center;
}

.SideDrawer_snapshotPieChart__XtarR {
  width: 100%;
}

.SideDrawer_snapshotPieStats__xCv\\+I {
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 12px;
  color: var(--color-text-muted);
}

.SideDrawer_snapshotPieStat__0mBSJ {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.SideDrawer_snapshotPieStat__0mBSJ strong {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-strong);
}

@media (max-width: 768px) {
  .SideDrawer_snapshotPieRow__SGagc {
    grid-template-columns: 1fr;
  }
}

.SideDrawer_deskReadStack__W9OPx {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.SideDrawer_deskReadList__T-cFC {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 0.875rem;
  color: var(--color-text-muted);
  line-height: 1.5;
}

.SideDrawer_deskReadItem__73xOz {
  display: flex;
  gap: 8px;
}

.SideDrawer_deskReadBullet__hTH6O {
  width: 6px;
  height: 6px;
  margin-top: 6px;
  border-radius: 999px;
  background: var(--color-accent);
  flex-shrink: 0;
}

.SideDrawer_summaryCardContent__hp-Wu {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.SideDrawer_summaryCardCompact__Efyj8 {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.SideDrawer_summaryRegimeRow__MoTuc {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.SideDrawer_summaryNotesIndented__n6Wqu {
  padding-left: 36px;
}

.SideDrawer_summaryBulletList__3wNTU {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: 36px;
}

.SideDrawer_summaryBulletItem__bEaZT {
  display: flex;
  gap: 8px;
}

.SideDrawer_summaryBulletDot__jYbbM {
  width: 6px;
  height: 6px;
  margin-top: 6px;
  border-radius: 999px;
  background: var(--color-accent);
  flex-shrink: 0;
}

.SideDrawer_summaryBulletLabel__tknaL {
  font-weight: 700;
  font-size: var(--font-size-label);
}

.SideDrawer_chartSummaryItems__mtkon {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.SideDrawer_chartSummaryItem__2ZMGi {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-weight: 700;
}

.SideDrawer_chartSummaryDot__qUnaM {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: currentColor;
  margin-top: 7px;
  flex-shrink: 0;
}

.SideDrawer_rowBetween__OfVzX {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.SideDrawer_rowWrap__mxLU8 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.SideDrawer_correlationStatLabel__Xj4nU {
  font-size: var(--font-size-label);
  text-transform: uppercase;
  color: var(--color-text-muted);
}

.SideDrawer_correlationStatRow__6kEsD {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.SideDrawer_correlationStatValue__zGeMY {
  font-size: var(--font-size-title);
  font-weight: 600;
  color: var(--color-text-strong);
}

.SideDrawer_correlationStatInline__-Rp95 {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
}

.SideDrawer_correlationStatInlineLabel__vAkSK {
  font-size: var(--font-size-label);
  color: var(--color-text-muted);
  text-transform: uppercase;
}

.SideDrawer_correlationStatInlineValue__5bV90 {
  font-size: var(--font-size-label);
  font-weight: 600;
  color: var(--color-text-strong);
}

.SideDrawer_correlationStatMeta__ipul6 {
  font-size: var(--font-size-label);
  color: var(--color-text-muted);
}

.SideDrawer_correlationStatStrength__fuXZ6 {
  font-size: var(--font-size-label);
  color: var(--color-text-muted);
}

.SideDrawer_correlationStatDivider__TJYuB {
  color: var(--color-text-muted);
  opacity: 0.6;
}

.SideDrawer_correlationText__Th2TB {
  font-size: var(--font-size-body);
  color: var(--color-text-muted);
}

.SideDrawer_correlationTextSmall__qtttH {
  font-size: var(--font-size-caption);
  color: var(--color-text-muted);
}

.SideDrawer_correlationHelpLinks__erfj0 {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.SideDrawer_helpGuideCard__aVHrX {
  padding: 12px;
  border-radius: 12px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-panel);
  color: var(--color-text-muted);
  font-size: var(--font-size-body);
  line-height: 1.5;
}

.SideDrawer_helpGuideTitle__EFqM0 {
  font-weight: 600;
  color: var(--color-text-strong);
  margin-bottom: 8px;
}

.SideDrawer_helpGuideSection__n5FqX {
  margin-bottom: 10px;
}

.SideDrawer_helpGuideHeading__iliUV {
  font-weight: 600;
  color: var(--color-text-strong);
  margin-bottom: 6px;
}

.SideDrawer_helpGuideSubheading__eZRsG {
  font-weight: 600;
  color: var(--color-text);
  margin: 6px 0 4px;
}

.SideDrawer_helpGuideList__eFF1s {
  margin: 6px 0 0;
  padding-left: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.SideDrawer_helpGuideQuote__GGZd2 {
  border-left: 2px solid var(--color-accent);
  padding-left: 8px;
  margin: 6px 0;
  color: var(--color-text);
}

.SideDrawer_helpGuideOverlay__iu2vM {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
}

.SideDrawer_helpGuideBackdrop__u0qRw {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(2px);
}

.SideDrawer_helpGuideModal__8EaXI {
  position: relative;
  z-index: 1;
  width: min(60vw, 760px);
  color: var(--color-text);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.45);
}

.SideDrawer_helpGuideHeader__o2z\\+6 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.SideDrawer_helpGuideHeaderTitle__vc4LI {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--color-text);
}

.SideDrawer_helpGuideClose__V3Drj {
  border: none;
  background: transparent;
  color: var(--color-text-muted);
  font-size: 1.2rem;
  cursor: pointer;
}

.SideDrawer_helpGuideBody__rF9CV {
  max-height: min(70vh, 720px);
  overflow: auto;
}

.SideDrawer_helpGuideTabs__ajuAu {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.SideDrawer_helpGuideTab__kRfJT {
  border: 1px solid var(--color-border);
  background: var(--color-bg-muted);
  color: var(--color-text-muted);
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
}

.SideDrawer_helpGuideTabActive__w84Us {
  background: var(--color-bg-panel);
  color: var(--color-text-strong);
}

.SideDrawer_helpGuidePlaceholder__ErNUa {
  color: var(--color-text-muted);
  font-size: 0.8rem;
}

.SideDrawer_alertsPanel__EsjIK {
  position: absolute;
  top: 40px;
  right: 10px;
  width: 340px;
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  padding: 16px;
  color: var(--color-text);
  z-index: 100;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
}

.SideDrawer_alertsPanelHeader__WHh-4 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--color-border);
}

.SideDrawer_alertsClose__3Mrfm {
  border: none;
  background: transparent;
  color: var(--color-text-muted);
  font-size: 1.2rem;
  cursor: pointer;
  transition: color 0.2s;
}

.SideDrawer_alertsClose__3Mrfm:hover {
  color: var(--color-text);
}

.SideDrawer_alertsToggle__AeqTW {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.75rem;
  color: var(--color-text-muted);
  margin-bottom: 12px;
}

.SideDrawer_alertsList__Sk\\+ek {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 260px;
  overflow-y: auto;
}

.SideDrawer_alertsItem__5IFwD {
  border: 1px solid var(--color-border);
  background: var(--color-bg-muted);
  border-radius: 10px;
  padding: 10px 12px;
  transition: border-color 0.2s;
}

.SideDrawer_alertsItem__5IFwD:hover {
  border-color: var(--color-text-muted);
}

.SideDrawer_alertsItemHeader__wdYzf {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.75rem;
}

.SideDrawer_alertsItemBadges__V8M9s {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.SideDrawer_alertModeBadge__HkiFS {
  border: 1px solid var(--color-accent);
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 0.6rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: var(--color-accent);
  background: rgba(99, 102, 241, 0.1);
}

.SideDrawer_alertsItemLabel__dlVCG {
  color: var(--color-text);
  font-weight: 500;
}

.SideDrawer_alertsSeverity__3Pp9m {
  text-transform: uppercase;
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.04em;
}

.SideDrawer_alertSeverityInfo__L3xvN {
  color: var(--color-accent);
}

.SideDrawer_alertSeverityWarning__tB6Uq {
  color: #f59e0b;
}

.SideDrawer_alertSeverityCritical__YJUAR {
  color: #ef4444;
}

.SideDrawer_alertsItemBody__A-j3F {
  margin-top: 6px;
  font-size: 0.75rem;
  color: var(--color-text-muted);
  line-height: 1.4;
}

.SideDrawer_alertsItemTimestamp__m0Eq9 {
  margin-top: 6px;
  font-size: 0.65rem;
  color: var(--color-text-muted);
}

/* Chart Panel */
.SideDrawer_chartPanel__gE8JE {
  margin-top: 24px;
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  padding: 20px;
}

.SideDrawer_chartHint__8WSw4 {
  color: var(--color-text-muted);
  font-size: 0.8rem;
  margin: 12px 0;
}

.SideDrawer_chartControls__bVwpS {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.SideDrawer_chartControlsRow__B23kS {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
  width: 100%;
}

.SideDrawer_trendMenu__A6Coz {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.SideDrawer_trendMenuButton__GNxdg {
  width: 32px;
  height: 32px;
  border-radius: 999px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-card);
  color: var(--color-text);
  font-size: 1.1rem;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
}

.SideDrawer_trendMenuButton__GNxdg:hover {
  border-color: var(--color-accent);
  background: var(--color-bg-muted);
}

.SideDrawer_trendMenuPanel__t3DAd {
  position: absolute;
  top: 40px;
  right: 0;
  width: 260px;
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 12px;
  z-index: 100;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
}

.SideDrawer_trendMenuGroup__2VKje {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 10px;
}

.SideDrawer_trendMenuGroup__2VKje:last-child {
  margin-bottom: 0;
}

.SideDrawer_trendMenuTitle__fk09J {
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-text-muted);
}

.SideDrawer_trendSelect__K2As0 {
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  color: var(--color-text);
  border-radius: 8px;
  padding: 6px 8px;
  font-size: 0.75rem;
}

.SideDrawer_trendSelect__K2As0:focus {
  outline: none;
  border-color: var(--color-accent);
}

.SideDrawer_trendToggle__KP1Pr {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.7rem;
  color: var(--color-text-muted);
}

.SideDrawer_trendToggle__KP1Pr input {
  accent-color: var(--color-accent);
}

.SideDrawer_chartWrapper__KUImj {
  background: var(--color-bg-muted);
  border-radius: 12px;
  border: 1px solid var(--color-border);
  padding: 16px 12px 10px;
  margin-top: 16px;
}

.SideDrawer_trendChartWrapper__wGySA {
  position: relative;
}

.SideDrawer_trendHelpIcon__Z09zU {
  position: absolute;
  top: 10px;
  right: 12px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid var(--color-border);
  background: var(--color-bg-card);
  color: var(--color-accent);
  font-size: 0.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: help;
  z-index: 3;
}

.SideDrawer_trendHelpTooltip__t3FX4 {
  position: absolute;
  top: 26px;
  right: 0;
  width: 320px;
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 12px;
  color: var(--color-text);
  font-size: 0.75rem;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-4px);
  transition: opacity 120ms ease-out, transform 120ms ease-out;
  z-index: 10;
  line-height: 1.4;
  text-align: left;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.SideDrawer_trendHelpTitle__PMI7W {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--color-text);
}

.SideDrawer_trendHelpItem__MlHOX {
  display: block;
  position: relative;
  padding-left: 14px;
  margin-bottom: 6px;
  color: var(--color-text-muted);
}

.SideDrawer_trendHelpItem__MlHOX::before {
  content: '•';
  position: absolute;
  left: 0;
  color: var(--color-accent);
}

.SideDrawer_trendHelpIcon__Z09zU:hover .SideDrawer_trendHelpTooltip__t3FX4,
.SideDrawer_trendHelpIcon__Z09zU:focus-visible .SideDrawer_trendHelpTooltip__t3FX4 {
  opacity: 1;
  transform: translateY(0);
}

.SideDrawer_chartHelp__MG1x\\+ {
  font-size: 0.8rem;
  color: var(--color-text-muted);
  margin-top: 12px;
}

.SideDrawer_columnName__3sQ6p {
  display: block;
  font-size: 0.7rem;
  font-weight: 500;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.SideDrawer_columnValue__vY2fd {
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--color-text);
  margin-top: 4px;
}

/* TradingView Section */
.SideDrawer_tradingViewWrap__1uIYM {
  margin-top: 20px;
  border: 1px solid var(--color-border);
  border-radius: 16px;
  background: var(--color-bg-card);
  overflow: hidden;
}

.SideDrawer_tradingViewChart__sC5\\+S {
  width: 100%;
  height: 360px;
}

/* Correlation Section */
.SideDrawer_correlationSection__5Q8EE {
  margin-top: 24px;
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  padding: 20px;
}

.SideDrawer_correlationHeader__VGHOE {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--color-border);
}

.SideDrawer_correlationHeaderLeft__cUqmr {
  flex: 1 1 auto;
}

.SideDrawer_correlationTitle__pdxTA {
  font-size: var(--font-size-title);
  font-weight: 600;
  color: var(--color-text);
  margin: 0;
}

.SideDrawer_correlationSubtitle__szVqB {
  font-size: var(--font-size-caption);
  color: var(--color-text-muted);
  margin: 4px 0 0;
}

.SideDrawer_correlationTourLink__GQrvr {
  background: transparent;
  border: none;
  color: var(--color-accent);
  font-size: var(--font-size-label);
  cursor: pointer;
  padding: 0;
  white-space: nowrap;
  text-decoration: underline;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.SideDrawer_correlationTourLink__GQrvr:hover {
  opacity: 0.8;
}

.SideDrawer_correlationViewToggle__Tu\\+9K {
  background: transparent;
  border: none;
  color: var(--color-accent);
  font-size: var(--font-size-caption);
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
}

.SideDrawer_correlationHeaderLabel__NTArm {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: var(--font-size-label);
  color: var(--color-accent);
}

.SideDrawer_correlationHeaderRight__2Ie-D .SideDrawer_correlationBadgeRow__bMxOT {
  margin-top: 0;
}

.SideDrawer_correlationMenuLabel__rl2Cj {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.SideDrawer_correlationInfoIcon__8KrCm {
  position: relative;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid var(--color-border);
  background: var(--color-bg-card);
  color: var(--color-text-muted);
  font-size: var(--font-size-tiny);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: help;
}

.SideDrawer_correlationInfoTooltip__IDnMV {
  position: absolute;
  top: 24px;
  left: 100%;
  margin-left: 8px;
  width: 280px;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-card);
  color: var(--color-text);
  font-size: var(--font-size-caption);
  line-height: 1.4;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-4px);
  transition: opacity 120ms ease-out, transform 120ms ease-out;
  z-index: 1000;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.SideDrawer_correlationInfoTitle__RX3LS {
  display: block;
  font-weight: 600;
  margin-bottom: 6px;
  color: var(--color-text);
}

.SideDrawer_correlationInfoText__5ce9R {
  display: block;
  margin: 6px 0;
  color: var(--color-text-muted);
}

.SideDrawer_correlationInfoIcon__8KrCm:hover .SideDrawer_correlationInfoTooltip__IDnMV,
.SideDrawer_correlationInfoIcon__8KrCm:focus-visible .SideDrawer_correlationInfoTooltip__IDnMV {
  opacity: 1;
  transform: translateY(0);
}

.SideDrawer_correlationControls__icafP {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  font-size: var(--font-size-label);
}

.SideDrawer_correlationLabelWithIcon__8Hw\\+T {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.SideDrawer_correlationSliderGroup__B44w4 {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.SideDrawer_correlationSliderRow__0mKIa {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.SideDrawer_correlationSliderRow__0mKIa input[type='range'] {
  width: 140px;
  accent-color: var(--color-accent);
}

.SideDrawer_correlationLagValue__69EIU {
  font-size: var(--font-size-caption);
  color: var(--color-text-muted);
  min-width: 32px;
  text-align: right;
}

.SideDrawer_correlationSliderTicks__tSGsh {
  display: flex;
  justify-content: space-between;
  width: 140px;
  font-size: var(--font-size-tiny);
  color: var(--color-accent);
  padding-left: 2px;
}

.SideDrawer_correlationTick__O1IDf {
  position: relative;
}

.SideDrawer_correlationTick__O1IDf::before {
  content: '';
  position: absolute;
  top: -6px;
  left: 50%;
  width: 1px;
  height: 6px;
  background: var(--color-border);
  transform: translateX(-50%);
}

.SideDrawer_correlationSliderAnchors__FE85W {
  display: flex;
  justify-content: space-between;
  width: 140px;
  font-size: var(--font-size-tiny);
  color: var(--color-text-muted);
}

.SideDrawer_correlationSummary__NhO6N {
  margin-top: 16px;
}

.SideDrawer_correlationValue__GfLBK {
  display: flex;
  align-items: baseline;
  gap: 8px;
  color: var(--color-text);
  font-size: var(--font-size-body);
}

.SideDrawer_correlationValue__GfLBK strong {
  font-size: var(--font-size-section);
}

.SideDrawer_correlationSample__6\\+gcA {
  font-size: var(--font-size-caption);
  color: var(--color-text-muted);
}

.SideDrawer_correlationBadgeRow__bMxOT {
  margin-top: 8px;
}

.SideDrawer_correlationBadge__98MBM {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 999px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-muted);
  font-size: 0.7rem;
  font-weight: 500;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.SideDrawer_correlationBadgeLow__UNKod {
  color: var(--color-text-muted);
}

.SideDrawer_correlationBadgeModerate__FLd5c {
  color: var(--color-text-muted);
}

.SideDrawer_correlationBadgeHigh__5lHj- {
  color: var(--color-accent);
  border-color: var(--color-accent);
  background: rgba(99, 102, 241, 0.1);
}

.SideDrawer_correlationInterpretation__XXoQP {
  margin-top: 6px;
  font-size: 0.78rem;
  color: var(--color-text-muted);
}

.SideDrawer_correlationInterpretationText__sNTkQ {
  margin-top: 6px;
  font-size: 0.75rem;
  color: var(--color-text-muted);
}

.SideDrawer_correlationHint__ZVMPq {
  margin-top: 6px;
  font-size: 0.72rem;
  color: var(--color-accent);
}

.SideDrawer_correlationFootnote__xALhf {
  margin-top: 8px;
  font-size: 0.7rem;
  color: var(--color-accent);
}

.SideDrawer_correlationWarning__0iZE7 {
  margin-top: 6px;
  font-size: 0.72rem;
  color: #f59e0b;
}

.SideDrawer_correlationSparkline__kPVdK {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid var(--color-border);
  cursor: pointer;
}

.SideDrawer_correlationSparklineTitle__1We3o {
  font-size: 0.7rem;
  color: var(--color-accent);
  margin-bottom: 8px;
}

.SideDrawer_correlationSparklineTooltip__7ty7H {
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  padding: 6px 10px;
  border-radius: 8px;
  color: var(--color-text);
  font-size: 0.7rem;
}

.SideDrawer_correlationMethodologyToggle__2nx9K {
  margin-top: 12px;
  background: transparent;
  border: none;
  color: var(--color-accent);
  font-size: 0.75rem;
  cursor: pointer;
  padding: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-decoration: underline;
}

.SideDrawer_correlationMethodologyChevron__mBK8s {
  font-size: 0.75rem;
  color: var(--color-accent);
}

.SideDrawer_correlationMethodologyText__Po1dj {
  margin-top: 10px;
  max-width: 700px;
  color: var(--color-text-muted);
  font-size: 0.75rem;
  line-height: 1.5;
}

.SideDrawer_correlationFooterAnchor__edAPz {
  height: 1px;
}

/* Tour Anchors */
.SideDrawer_tourAnchorActive__tZwby {
  outline: 2px solid var(--color-accent);
  outline-offset: 4px;
  border-radius: 8px;
}

/* Positioning Tour Popover */
.SideDrawer_positioningTourPopover__MyRe1 {
  position: fixed;
  width: 340px;
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  padding: 16px;
  color: var(--color-text);
  font-size: 0.75rem;
  z-index: 1000;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
}

.SideDrawer_positioningTourHeading__O0CsR {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--color-text);
  margin-bottom: 6px;
}

.SideDrawer_positioningTourStep__mQJFS {
  font-size: 0.7rem;
  color: var(--color-accent);
  margin-bottom: 8px;
}

.SideDrawer_positioningTourTitle__TkYHa {
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 10px;
}

.SideDrawer_positioningTourText__lx-\\+8 {
  margin: 6px 0;
  color: var(--color-text-muted);
  line-height: 1.4;
}

.SideDrawer_positioningTourList__Aio2- {
  margin: 6px 0;
  padding-left: 20px;
  color: var(--color-text-muted);
}

.SideDrawer_positioningTourListItem__OTx8l {
  margin-bottom: 6px;
}

.SideDrawer_positioningTourExample__GqAU0 {
  margin-top: 10px;
  color: var(--color-text-muted);
}

.SideDrawer_positioningTourBold__t1G6N {
  margin-top: 10px;
  font-weight: 600;
  color: var(--color-text);
}

.SideDrawer_positioningTourActions__lsBM7 {
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.SideDrawer_positioningTourActionGroup__nL\\+3V {
  display: inline-flex;
  gap: 8px;
}

.SideDrawer_positioningTourSkip__OyyFz {
  background: transparent;
  border: none;
  color: var(--color-accent);
  font-size: 0.75rem;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
}

.SideDrawer_positioningTourBack__tSCsF,
.SideDrawer_positioningTourNext__YGEdu {
  background: var(--color-bg-muted);
  border: 1px solid var(--color-border);
  color: var(--color-text);
  font-size: 0.75rem;
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
}

.SideDrawer_positioningTourBack__tSCsF:hover,
.SideDrawer_positioningTourNext__YGEdu:hover {
  border-color: var(--color-text-muted);
}

.SideDrawer_positioningTourNext__YGEdu {
  background: var(--color-accent);
  border-color: var(--color-accent);
  color: white;
}

.SideDrawer_positioningTourBack__tSCsF:disabled {
  opacity: 0.5;
  cursor: default;
}

/* Signals Tour Popover */
.SideDrawer_signalsTourPopover__n4v6a {
  position: fixed;
  width: min(92vw, 420px);
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  padding: 16px 18px;
  color: var(--color-text);
  font-size: 0.75rem;
  z-index: 1000;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
}

.SideDrawer_signalsTourHeading__rwYfW {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--color-text);
  margin-bottom: 6px;
}

.SideDrawer_signalsTourStep__A3VxO {
  font-size: 0.7rem;
  color: var(--color-accent);
  margin-bottom: 10px;
}

.SideDrawer_signalsTourTitle__M7x5W {
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 10px;
}

.SideDrawer_signalsTourBody__I2Z3x {
  color: var(--color-text-muted);
  margin-bottom: 10px;
  line-height: 1.4;
}

.SideDrawer_signalsTourExample__x0EfT {
  color: var(--color-text-muted);
  margin-bottom: 10px;
}

.SideDrawer_signalsTourSections__oR7ta {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 10px;
}

.SideDrawer_signalsTourSectionTitle__sqCpv {
  font-weight: 600;
  margin-bottom: 6px;
  color: var(--color-text-muted);
}

.SideDrawer_signalsTourSectionList__G9pBI {
  margin: 0;
  padding-left: 20px;
}

.SideDrawer_signalsTourSectionItem__QMhf\\+ {
  margin-bottom: 6px;
  color: var(--color-text-muted);
}

.SideDrawer_signalsTourBulletsTitle__zl6VG {
  color: var(--color-text-muted);
  margin-bottom: 6px;
  font-weight: 600;
}

.SideDrawer_signalsTourBullets__cqNJp {
  margin: 6px 0 0;
  padding-left: 20px;
}

.SideDrawer_signalsTourBullet__-nNON {
  margin-bottom: 6px;
  color: var(--color-text-muted);
}

.SideDrawer_signalsTourClosing__bbM\\+S {
  margin-top: 10px;
  color: var(--color-text-muted);
}

.SideDrawer_signalsTourFooter__ZxOAk {
  margin-top: 10px;
  color: var(--color-accent);
  font-weight: 600;
}

.SideDrawer_signalsTourBold__n7czE {
  margin-top: 10px;
  font-weight: 600;
  color: var(--color-text);
}

.SideDrawer_signalsTourActions__jTGC\\+ {
  margin-top: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.SideDrawer_signalsTourActionGroup__r-QH3 {
  display: inline-flex;
  gap: 8px;
}

.SideDrawer_signalsTourSkip__2PgmG {
  background: transparent;
  border: none;
  color: var(--color-accent);
  font-size: 0.75rem;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
}

.SideDrawer_signalsTourBack__poy1v,
.SideDrawer_signalsTourNext__0cafc,
.SideDrawer_signalsTourDone__n68Vk {
  background: var(--color-bg-muted);
  border: 1px solid var(--color-border);
  color: var(--color-text);
  font-size: 0.75rem;
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
}

.SideDrawer_signalsTourBack__poy1v:hover,
.SideDrawer_signalsTourNext__0cafc:hover,
.SideDrawer_signalsTourDone__n68Vk:hover {
  border-color: var(--color-text-muted);
}

.SideDrawer_signalsTourNext__0cafc,
.SideDrawer_signalsTourDone__n68Vk {
  background: var(--color-accent);
  border-color: var(--color-accent);
  color: white;
}

.SideDrawer_tourIcon__n0pbZ {
  font-size: 0.75rem;
  display: inline-flex;
}

.SideDrawer_signalsTourBack__poy1v:disabled {
  opacity: 0.5;
  cursor: default;
}

/* Loading & Error States */
.SideDrawer_loadingState__rbw0k,
.SideDrawer_errorState__0y3Hn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.SideDrawer_loadingState__rbw0k {
  color: var(--color-text-muted);
}

.SideDrawer_errorState__0y3Hn {
  color: #ef4444;
}

.SideDrawer_loadingSpinner__SxnZ\\+ {
  width: 40px;
  height: 40px;
  border: 3px solid var(--color-border);
  border-top-color: var(--color-accent);
  border-radius: 50%;
  animation: SideDrawer_spin__zJSrE 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes SideDrawer_spin__zJSrE {
  to {
    transform: rotate(360deg);
  }
}

/* Empty State */
.SideDrawer_emptyState__VFiDv {
  padding: 40px 20px;
  text-align: center;
  color: var(--color-text-muted);
}

.SideDrawer_emptyStateIcon__cTKrl {
  font-size: 3rem;
  margin-bottom: 16px;
  opacity: 0.5;
}

.SideDrawer_emptyStateText__INeuL {
  font-size: 0.9rem;
}

/* Responsive */
@media (max-width: 768px) {
  .SideDrawer_drawer__8TBjj {
    padding: 16px;
  }

  .SideDrawer_drawerHeader__5-7-c {
    flex-direction: column;
    gap: 12px;
  }

  .SideDrawer_summaryGrid__SXo0H {
    grid-template-columns: repeat(2, 1fr);
  }

  .SideDrawer_detailList__wNb1N {
    grid-template-columns: 1fr;
  }

  .SideDrawer_correlationControls__icafP {
    flex-direction: column;
    align-items: flex-start;
  }
}

/* Readiness Badge Styles */
.SideDrawer_readinessDefinitionList__i1fuV {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.SideDrawer_readinessDefinitionItem__vz1nd {
  display: block;
  line-height: 1.5;
}

.SideDrawer_readinessDefinition__JCLf5 {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-bottom: 0.75rem;
}

.SideDrawer_readinessDefinitionTitle__fKWKB {
  font-weight: 600;
  margin-bottom: 0.25rem;
}
.SideDrawer_sparklesIcon__uPKsE {
  color: var(--color-warning);
  font-size: 1em;
  flex-shrink: 0;
}

.SideDrawer_helpGuideHeadingWithIcon__Cm8T- {
  display: flex;
  align-items: center;
  gap: 8px;
}

.SideDrawer_signalsTourHeading__rwYfW {
  display: flex;
  align-items: center;
  gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/SideDrawer/SideDrawer.module.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,oDAAoD;IACpD,kBAAkB;EACpB;;EAEA;IACE,oDAAoD;IACpD,oBAAoB;EACtB;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,iBAAiB;EACjB,uCAAuC;EACvC,qBAAqB;EACrB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,gCAAgC;EAChC,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;IAChD,gBAAgB;EAClB;AACF;;AAEA,aAAa;AACb;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;EACtB,iCAAiC;EACjC,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,qCAAqC;EACrC,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,qCAAqC;EACrC,gCAAgC;EAChC,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,2BAA2B;EAC3B,4DAA4D;EAC5D,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,0BAA0B;AAC5B;;AAEA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,qCAAqC;EACrC,gCAAgC;EAChC,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,2BAA2B;EAC3B,4DAA4D;EAC5D,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,iCAAiC;EACjC,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,0BAA0B;EAC1B,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,2BAA2B;EAC3B,4DAA4D;EAC5D,YAAY;EACZ,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,0BAA0B;AAC5B;;AAEA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,0BAA0B;EAC1B,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,2BAA2B;EAC3B,4DAA4D;EAC5D,YAAY;EACZ,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,qCAAqC;EACrC,gCAAgC;EAChC,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,uBAAuB;EACvB,iCAAiC;EACjC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,2BAA2B;EAC3B,4DAA4D;EAC5D,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,4DAA4D;AAC5D;EACE,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,qCAAqC;EACrC,iCAAiC;EACjC,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,qCAAqC;EACrC,gCAAgC;EAChC,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,iCAAiC;EACjC,YAAY;EACZ,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;EACjB,iCAAiC;EACjC,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,mCAAmC;EACnC,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,iCAAiC;EACjC,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,iCAAiC;EACjC,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,iCAAiC;EACjC,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,iCAAiC;EACjC,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,0CAA0C;EAC1C,iBAAiB;EACjB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,wBAAwB;EACxB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,gCAAgC;EAChC,wBAAwB;EACxB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,qCAAqC;EACrC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,2BAA2B;EAC3B,4DAA4D;EAC5D,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,0BAA0B;AAC5B;;AAEA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,iCAAiC;EACjC,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,mCAAmC;EACnC,eAAe;EACf,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,8BAA8B;EAC9B,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,gCAAgC;EAChC,wBAAwB;EACxB,mCAAmC;EACnC,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,2BAA2B;EAC3B,4DAA4D;EAC5D,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,gCAAgC;EAChC,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,YAAY;EACZ,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,0BAA0B;AAC5B;;AAEA;;EAEE,iCAAiC;EACjC,qCAAqC;EACrC,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,uBAAuB;EACvB,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,0BAA0B;AAC5B;;AAEA;;;EAGE,iCAAiC;EACjC,qCAAqC;EACrC,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;;EAEE,+BAA+B;EAC/B,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;EAClB,oDAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAC3B,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV","sourcesContent":["/* Main Drawer Container */\n.drawer {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  padding: 24px;\n  color: var(--color-text);\n  background: var(--color-bg);\n}\n\n.snapshotSummaryGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 24px;\n  margin-bottom: 24px;\n}\n\n.snapshotSummaryRowHalf {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 24px;\n  margin-bottom: 24px;\n  align-items: stretch;\n}\n\n.snapshotSummaryControls {\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 16px;\n}\n\n.snapshotColumn {\n  min-width: 0;\n}\n\n.snapshotColumn .drawerHeader {\n  height: 100%;\n}\n\n.summaryColumn {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.summaryHeaderRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.sectionTitle {\n  font-size: var(--font-size-title);\n  font-weight: 600;\n  color: var(--color-text-strong);\n}\n\n.pillsRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.summaryColumnStack {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n@media (min-width: 1024px) {\n  .snapshotSummaryGrid {\n    grid-template-columns: minmax(0, 3fr) minmax(0, 7fr);\n    align-items: start;\n  }\n\n  .snapshotSummaryRowHalf {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n    align-items: stretch;\n  }\n}\n\n/* Header Section */\n.drawerHeader {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 0;\n  padding: 16px;\n  background-color: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n}\n\n.drawerHeader h3 {\n  margin: 0;\n  font-size: var(--font-size-title);\n  font-weight: 700;\n  color: var(--color-text);\n  letter-spacing: -0.02em;\n}\n\n.drawerHeader p {\n  margin: 8px 0 0;\n  color: var(--color-text-muted);\n  font-size: var(--font-size-body);\n  line-height: 1.4;\n}\n\n.snapshotCode {\n  margin-top: 6px;\n  font-size: var(--font-size-label);\n  color: var(--color-text-muted);\n  font-weight: 600;\n}\n\n.snapshotTicker {\n  margin-top: 6px;\n  font-size: var(--font-size-label);\n  color: var(--color-text-muted);\n}\n\n.snapshotTickerRow {\n  margin-top: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.snapshotTickerLabel {\n  font-size: var(--font-size-label);\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-weight: 600;\n}\n\n.snapshotTickerInput {\n  background: var(--color-bg-alt);\n  border: 1px solid var(--color-border);\n  color: var(--color-text);\n  border-radius: 8px;\n  padding: 8px 10px;\n  font-size: var(--font-size-body);\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.snapshotTickerInline {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 100%;\n}\n\n.snapshotTickerDisplay {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-alt);\n  font-size: var(--font-size-body);\n  color: var(--color-text);\n}\n\n.snapshotTickerEditButton {\n  border: none;\n  background: transparent;\n  color: var(--color-text-muted);\n  font-size: var(--font-size-body);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.snapshotTickerEditButton:hover {\n  color: var(--color-text);\n}\n\n.drawerDate {\n  font-size: var(--font-size-label);\n  color: var(--color-text-muted);\n  padding: 8px 16px;\n  background-color: var(--color-bg-muted);\n  border-radius: 9999px;\n  border: 1px solid var(--color-border);\n  white-space: nowrap;\n  font-weight: 500;\n}\n\n/* Record Select Grid */\n.recordSelect {\n  margin-top: 12px;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n}\n\n.snapshotControls {\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n.snapshotRow {\n  display: block;\n}\n\n.snapshotRowTwo,\n.snapshotRowThree {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n}\n\n.snapshotColumnStack {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n  align-items: stretch;\n}\n\n.selectFieldRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.selectFieldRow select {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.selectField {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.selectField select {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.reportDatePicker {\n  display: flex;\n  gap: 8px;\n}\n\n.reportDatePicker select {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.inlineLabel {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.selectField select {\n  border-radius: 10px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-card);\n  color: var(--color-text);\n  padding: 8px 12px;\n  font-size: 0.85rem;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.selectField select:hover {\n  border-color: var(--color-text-muted);\n}\n\n.selectField select:focus {\n  outline: none;\n  border-color: var(--color-accent);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);\n}\n\n.purchaserSelect {\n  margin-top: 16px;\n}\n\n.advancedDisclosure {\n  margin-top: 12px;\n  border-top: 1px solid var(--color-border);\n  padding-top: 10px;\n}\n\n.advancedSummary {\n  cursor: pointer;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--color-text-muted);\n  list-style: none;\n}\n\n.advancedSummary::-webkit-details-marker {\n  display: none;\n}\n\n.advancedPanel {\n  margin-top: 8px;\n  font-size: 0.8rem;\n  color: var(--color-text-muted);\n}\n\n@media (min-width: 768px) {\n  .recordSelect {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .snapshotRowTwo {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .snapshotRowThree {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 1024px) {\n  .recordSelect {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  .snapshotRowTwo {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .snapshotRowThree {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .impactReportControls {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    align-items: end;\n  }\n}\n\n/* Tab List */\n.tabList {\n  display: flex;\n  gap: 8px;\n  margin-top: 20px;\n  padding: 4px;\n  background: var(--color-bg-card);\n  border-radius: 12px;\n  border: 1px solid var(--color-border);\n}\n\n.tabButton {\n  flex: 1;\n  border: none;\n  background: transparent;\n  color: var(--color-text-muted);\n  font-size: 0.9rem;\n  font-weight: 500;\n  padding: 10px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.tabButton:hover {\n  color: var(--color-text);\n  background: var(--color-bg-muted);\n}\n\n.tabButtonActive {\n  background: var(--color-accent);\n  color: white;\n}\n\n/* Summary Grid */\n.summaryGrid {\n  margin-top: 20px;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 12px;\n}\n\n.summaryCard {\n  background: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 16px;\n  transition: border-color 0.2s, transform 0.2s;\n}\n\n.summaryCard:hover {\n  border-color: var(--color-text-muted);\n  transform: translateY(-2px);\n}\n\n.summaryCard span {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.summaryCard strong {\n  display: block;\n  margin-top: 8px;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--color-text);\n}\n\n/* Detail List */\n.detailList {\n  margin-top: 16px;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.detailItem {\n  background: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  border-radius: 10px;\n  padding: 12px;\n}\n\n.detailItem dt {\n  font-size: 0.7rem;\n  font-weight: 500;\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.detailItem dd {\n  margin: 6px 0 0;\n  font-weight: 600;\n  font-size: 1rem;\n  color: var(--color-text);\n}\n\n/* Columns Section */\n.columnsSection {\n  margin-top: 24px;\n  background: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  padding: 20px;\n}\n\n.columnsHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.columnsHeader h4 {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.columnsHeader p {\n  margin: 0;\n  font-size: 0.75rem;\n  color: var(--color-text-muted);\n}\n\n.columnGroups {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 16px;\n}\n\n.columnGroup strong {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--color-accent);\n}\n\n.columnGroup ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  font-size: 0.8rem;\n  color: var(--color-text-muted);\n}\n\n.columnGroup li {\n  margin-bottom: 6px;\n  padding-left: 12px;\n  position: relative;\n}\n\n.columnGroup li::before {\n  content: '•';\n  position: absolute;\n  left: 0;\n  color: var(--color-border);\n}\n\n/* Purchaser Table */\n.purchaserTableWrap {\n  margin-top: 24px;\n  background: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  padding: 20px;\n}\n\n.purchaserTableWrap h4 {\n  margin: 0 0 16px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.tableScroller {\n  overflow: visible;\n  max-height: none;\n  margin-top: 8px;\n}\n\n.purchaserTable {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.purchaserTable th,\n.purchaserTable td {\n  border-bottom: 1px solid var(--color-border);\n  padding: 12px 10px;\n  text-align: left;\n}\n\n.purchaserTable th {\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  background: var(--color-bg-muted);\n  position: sticky;\n  top: 0;\n}\n\n.purchaserTable td {\n  color: var(--color-text);\n}\n\n.purchaserTable tbody tr:hover {\n  background: var(--color-bg-muted);\n}\n\n.purchaserTable tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.changeCell {\n  font-weight: 600;\n}\n\n/* Chart Headings */\n.chartHeading {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  margin-bottom: 12px;\n  font-size: 0.9rem;\n  color: var(--color-text-muted);\n}\n\n.chartHeading span {\n  font-size: 0.8rem;\n  color: var(--color-accent);\n}\n\n/* Trend Heading */\n.trendHeading {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  margin: 8px 0 12px;\n  color: var(--color-text);\n}\n\n.trendHeadingLeft {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.trendViewLabel {\n  font-size: 0.7rem;\n  color: var(--color-accent);\n  border: 1px solid var(--color-accent);\n  border-radius: 999px;\n  padding: 4px 12px;\n  text-transform: none;\n  white-space: nowrap;\n  background: rgba(99, 102, 241, 0.1);\n}\n\n.trendHeadingMeta {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  margin-left: auto;\n}\n\n.regimeBadgeGroup {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.regimeBadge {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border-radius: 999px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-card);\n  color: var(--color-text);\n  font-size: 0.7rem;\n  font-weight: 600;\n  padding: 4px 10px;\n  cursor: help;\n}\n\n.regimeTooltip {\n  position: absolute;\n  top: 26px;\n  right: 0;\n  width: 260px;\n  background: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 12px;\n  color: var(--color-text);\n  font-size: 0.75rem;\n  opacity: 0;\n  pointer-events: none;\n  transform: translateY(-4px);\n  transition: opacity 120ms ease-out, transform 120ms ease-out;\n  z-index: 100;\n  line-height: 1.4;\n  text-align: left;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.regimeTooltipList {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.regimeTooltipItem {\n  position: relative;\n  padding-left: 14px;\n  color: var(--color-text-muted);\n}\n\n.regimeTooltipItem::before {\n  content: '•';\n  position: absolute;\n  left: 0;\n  color: var(--color-accent);\n}\n\n.regimeBadge:hover .regimeTooltip,\n.regimeBadge:focus-visible .regimeTooltip {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.grossBadge {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border-radius: 999px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-card);\n  color: var(--color-text);\n  font-size: 0.7rem;\n  font-weight: 500;\n  padding: 4px 10px;\n  cursor: help;\n}\n\n.grossBadgeElevated {\n  color: var(--color-warning);\n  border-color: var(--color-warning);\n}\n\n.grossBadgeLow {\n  color: var(--color-success);\n  border-color: var(--color-success);\n}\n\n.grossBadgeNormal {\n  color: var(--color-text-muted);\n}\n\n.grossTooltip {\n  position: absolute;\n  top: 26px;\n  right: 0;\n  width: 280px;\n  background: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 12px;\n  color: var(--color-text);\n  font-size: 0.75rem;\n  opacity: 0;\n  pointer-events: none;\n  transform: translateY(-4px);\n  transition: opacity 120ms ease-out, transform 120ms ease-out;\n  z-index: 100;\n  line-height: 1.4;\n  text-align: left;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.grossTooltipLine {\n  display: block;\n  margin-bottom: 6px;\n  color: var(--color-text-muted);\n}\n\n.grossTooltipNote {\n  display: block;\n  margin-top: 6px;\n  color: var(--color-warning);\n  font-weight: 600;\n}\n\n.grossBadge:hover .grossTooltip,\n.grossBadge:focus-visible .grossTooltip {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.signalsTourLink {\n  background: transparent;\n  border: none;\n  color: var(--color-accent);\n  font-size: var(--font-size-label);\n  cursor: pointer;\n  padding: 0;\n  white-space: nowrap;\n  text-decoration: underline;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.signalsTourLinkLeft {\n  margin-right: auto;\n}\n\n.signalsTourLink:hover {\n  opacity: 0.8;\n}\n\n/* Regime Help Icon */\n.regimeHelpIcon {\n  position: relative;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-card);\n  color: var(--color-accent);\n  font-size: 0.7rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: help;\n}\n\n.regimeHelpTooltip {\n  position: absolute;\n  top: 26px;\n  right: 0;\n  width: 280px;\n  background: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 12px;\n  color: var(--color-text);\n  font-size: 0.75rem;\n  opacity: 0;\n  pointer-events: none;\n  transform: translateY(-4px);\n  transition: opacity 120ms ease-out, transform 120ms ease-out;\n  z-index: 100;\n  text-align: left;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.regimeHelpTitle {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: var(--color-text);\n}\n\n.regimeHelpList {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.regimeHelpItem {\n  position: relative;\n  padding-left: 14px;\n  line-height: 1.4;\n  color: var(--color-text-muted);\n}\n\n.regimeHelpItem::before {\n  content: '•';\n  position: absolute;\n  left: 0;\n  color: var(--color-accent);\n}\n\n.regimeHelpIcon:hover .regimeHelpTooltip,\n.regimeHelpIcon:focus-visible .regimeHelpTooltip {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* Price Reference Control */\n.priceReferenceControl {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.75rem;\n  color: var(--color-text-muted);\n}\n\n.priceReferenceLabel {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.7rem;\n  color: var(--color-text-muted);\n  white-space: nowrap;\n}\n\n.priceReferenceInfoIcon {\n  position: relative;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-card);\n  color: var(--color-accent);\n  font-size: 0.7rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: help;\n}\n\n.priceReferenceTooltip {\n  position: absolute;\n  top: 26px;\n  right: 0;\n  width: 280px;\n  background: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 12px;\n  color: var(--color-text);\n  font-size: 0.75rem;\n  opacity: 0;\n  pointer-events: none;\n  transform: translateY(-4px);\n  transition: opacity 120ms ease-out, transform 120ms ease-out;\n  z-index: 100;\n  line-height: 1.4;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.priceReferenceInfoIcon:hover .priceReferenceTooltip,\n.priceReferenceInfoIcon:focus-visible .priceReferenceTooltip {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.priceReferenceSelect {\n  background: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  color: var(--color-text);\n  border-radius: 8px;\n  padding: 4px 10px;\n  font-size: 0.75rem;\n  transition: border-color 0.2s;\n}\n\n.priceReferenceSelect:hover {\n  border-color: var(--color-text-muted);\n}\n\n.readinessBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  border-radius: 999px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-card);\n  color: var(--color-text);\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 6px 12px;\n  position: relative;\n}\n\n.readinessInfoIcon {\n  position: relative;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-card);\n  color: var(--color-text-muted);\n  font-size: 0.7rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: help;\n}\n\n.readinessTooltip {\n  position: absolute;\n  top: 0;\n  left: 26px;\n  width: min(40vw, 520px);\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  padding: 12px;\n  color: var(--color-text);\n  font-size: 0.75rem;\n  opacity: 0;\n  pointer-events: none;\n  transform: translateY(-4px);\n  transition: opacity 120ms ease-out, transform 120ms ease-out;\n  z-index: 120;\n  line-height: 1.4;\n  text-align: left;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.readinessInfoIcon:hover .readinessTooltip,\n.readinessInfoIcon:focus-visible .readinessTooltip {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.readinessTooltipTitle {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: var(--color-text);\n}\n\n.readinessTooltipRowGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.readinessTooltipSection {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.readinessTooltipRow {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  color: var(--color-text-muted);\n}\n\n.readinessTooltipLabel {\n  color: var(--color-text);\n  font-weight: 500;\n}\n\n.trendHeading h4,\n.trendHeading span {\n  color: var(--color-text);\n}\n\n.trendTooltip {\n  background: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 10px 12px;\n  color: var(--color-text);\n  font-size: 0.75rem;\n  line-height: 1.4;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.trendTooltipLabel {\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.trendTooltipPrice {\n  margin-top: 4px;\n  color: var(--color-text-muted);\n}\n\n.trendTooltipOi {\n  margin-top: 4px;\n  color: var(--color-text-muted);\n}\n\n.trendTooltipInsight {\n  margin-top: 6px;\n  color: var(--color-accent);\n  font-weight: 600;\n}\n\n.trendTooltipDetails {\n  margin-top: 6px;\n  color: var(--color-text-muted);\n}\n\n.trendRange {\n  color: var(--color-text);\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-align: right;\n}\n\n/* CFTC Trend Tooltip (Landing page style guide alignment) */\n.cftcTooltipCard {\n  width: 440px;\n  max-width: 90vw;\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  padding: 16px;\n  color: var(--color-text);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.cftcTooltipHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.cftcTooltipTitle {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.cftcTooltipBadge {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 999px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-muted);\n  padding: 4px 10px;\n  font-size: 0.6rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--color-text-strong);\n}\n\n.cftcTooltipMeta {\n  margin-top: 6px;\n  font-size: 0.75rem;\n  color: var(--color-text-muted);\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.cftcTooltipDesk {\n  margin-top: 12px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-muted);\n}\n\n.cftcTooltipDeskLabel {\n  font-size: 0.6rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: var(--color-text-muted);\n}\n\n.cftcTooltipDeskBody {\n  margin-top: 6px;\n  border-left: 2px solid var(--color-accent);\n  padding-left: 10px;\n  font-size: 0.75rem;\n  color: var(--color-text-strong);\n  line-height: 1.4;\n}\n\n.cftcTooltipActors {\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.cftcTooltipActor {\n  padding: 10px 12px;\n  border-radius: 12px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-muted);\n}\n\n.cftcTooltipActorRow {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.cftcTooltipActorLabel {\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.cftcTooltipActorMeta {\n  margin-top: 4px;\n  font-size: 0.7rem;\n  color: var(--color-text-muted);\n}\n\n.cftcTooltipActorRight {\n  text-align: right;\n}\n\n.cftcTooltipActorNet {\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n/* Alerts Button & Panel */\n.alertsButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 999px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-card);\n  color: var(--color-text);\n  font-size: 0.75rem;\n  font-weight: 500;\n  padding: 6px 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.alertsButton:hover {\n  border-color: var(--color-accent);\n  background: var(--color-bg-muted);\n}\n\n.alertsCount {\n  background: var(--color-accent);\n  color: white;\n  border-radius: 999px;\n  padding: 2px 8px;\n  font-size: var(--font-size-tiny);\n  font-weight: 600;\n}\n\n.summaryMuted {\n  font-size: var(--font-size-caption);\n  color: var(--color-text-muted);\n}\n\n.summaryStrong {\n  font-size: var(--font-size-body);\n  font-weight: 600;\n  color: var(--color-text-strong);\n}\n\n.summaryText {\n  font-size: var(--font-size-body);\n  color: var(--color-text-muted);\n}\n\n.summaryBanner {\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  background: var(--color-bg-muted);\n  padding: 8px;\n  font-size: var(--font-size-caption);\n  color: var(--color-text-muted);\n}\n\n.summaryWarning {\n  color: var(--color-warning);\n}\n\n.panelCard {\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  background: var(--color-bg-panel);\n  padding: 24px;\n}\n\n.panelTitle {\n  font-size: var(--font-size-label);\n  font-weight: 600;\n  color: var(--color-text-strong);\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.panelTitleSmall {\n  font-size: var(--font-size-body);\n  font-weight: 600;\n  color: var(--color-text-strong);\n  margin-bottom: 8px;\n}\n\n.panelBody {\n  margin-top: 12px;\n}\n\n.impactReportControls {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.impactReportGenerateCol {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.impactReportGenerateButton {\n  border: 1px solid var(--color-accent);\n  background: var(--color-accent);\n  color: #fff;\n  border-radius: 10px;\n  padding: 10px 14px;\n  font-size: var(--font-size-body);\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.impactReportGenerateButton:hover {\n  opacity: 0.92;\n}\n\n.impactReportGroupGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.impactReportGroupOption {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid var(--color-border);\n  border-radius: 10px;\n  padding: 8px 10px;\n  background: var(--color-bg-muted);\n  color: var(--color-text);\n  font-size: var(--font-size-body);\n}\n\n.impactReportGroupOption input {\n  accent-color: var(--color-accent);\n}\n\n.impactReportSummary {\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  background: var(--color-bg-muted);\n  padding: 12px;\n  margin-bottom: 12px;\n}\n\n.impactReportSection {\n  margin-bottom: 12px;\n}\n\n.impactReportList {\n  margin: 0;\n  padding-left: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: var(--font-size-body);\n  color: var(--color-text-muted);\n}\n\n.impactRiskBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  padding: 3px 10px;\n  font-size: var(--font-size-caption);\n  font-weight: 600;\n  border: 1px solid var(--color-border);\n}\n\n.impactRiskHigh {\n  color: var(--color-danger);\n  border-color: var(--color-danger);\n}\n\n.impactRiskModerate {\n  color: var(--color-warning);\n  border-color: var(--color-warning);\n}\n\n.impactRiskLow {\n  color: var(--color-success);\n  border-color: var(--color-success);\n}\n\n.snapshotDonutWrap {\n  margin-bottom: 16px;\n  min-height: 260px;\n}\n\n.snapshotDonutGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 16px;\n  align-items: stretch;\n}\n\n.snapshotDonutCard {\n  padding: 12px;\n  border-radius: 12px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-panel);\n  height: 100%;\n  min-height: 240px;\n}\n\n.snapshotDonutCard :global(.js-plotly-plot),\n.snapshotDonutCard :global(.plot-container),\n.snapshotDonutCard :global(.svg-container) {\n  height: 100% !important;\n}\n\n.snapshotDonutCard :global(.slice text),\n.snapshotDonutCard :global(.legend text),\n.snapshotDonutCard :global(.gtitle),\n.snapshotDonutCard :global(.infolayer text) {\n  font-weight: 700;\n}\n\n.snapshotDonutLabel {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-text-strong);\n  margin-bottom: 6px;\n}\n\n.snapshotChartHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.snapshotChartTitle {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-text-strong);\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.snapshotChangeCharts {\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n}\n\n.snapshotChangeGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 16px;\n}\n\n.snapshotChangeCard {\n  padding: 12px;\n  border-radius: 12px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-panel);\n  height: 100%;\n  min-height: 260px;\n  display: flex;\n  flex-direction: column;\n}\n\n.snapshotChangeTitle {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-text-strong);\n  margin-bottom: 6px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.snapshotChangeCard :global(.js-plotly-plot),\n.snapshotChangeCard :global(.plot-container),\n.snapshotChangeCard :global(.svg-container) {\n  height: 100% !important;\n}\n\n.snapshotPieWrap {\n  margin-top: 16px;\n}\n\n.snapshotPieGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n}\n\n.snapshotPieCard {\n  padding: 12px;\n  border-radius: 12px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-panel);\n  height: 100%;\n  min-height: 220px;\n  display: flex;\n  flex-direction: column;\n}\n\n.snapshotPieCard :global(.js-plotly-plot),\n.snapshotPieCard :global(.plot-container),\n.snapshotPieCard :global(.svg-container) {\n  height: 100% !important;\n}\n\n.snapshotPieRow {\n  display: grid;\n  grid-template-columns: 1.2fr 0.8fr;\n  gap: 12px;\n  align-items: center;\n}\n\n.snapshotPieChart {\n  width: 100%;\n}\n\n.snapshotPieStats {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  font-size: 12px;\n  color: var(--color-text-muted);\n}\n\n.snapshotPieStat {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.snapshotPieStat strong {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text-strong);\n}\n\n@media (max-width: 768px) {\n  .snapshotPieRow {\n    grid-template-columns: 1fr;\n  }\n}\n\n.deskReadStack {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.deskReadList {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: 0.875rem;\n  color: var(--color-text-muted);\n  line-height: 1.5;\n}\n\n.deskReadItem {\n  display: flex;\n  gap: 8px;\n}\n\n.deskReadBullet {\n  width: 6px;\n  height: 6px;\n  margin-top: 6px;\n  border-radius: 999px;\n  background: var(--color-accent);\n  flex-shrink: 0;\n}\n\n.summaryCardContent {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.summaryCardCompact {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.summaryRegimeRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n}\n\n.summaryNotesIndented {\n  padding-left: 36px;\n}\n\n.summaryBulletList {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-left: 36px;\n}\n\n.summaryBulletItem {\n  display: flex;\n  gap: 8px;\n}\n\n.summaryBulletDot {\n  width: 6px;\n  height: 6px;\n  margin-top: 6px;\n  border-radius: 999px;\n  background: var(--color-accent);\n  flex-shrink: 0;\n}\n\n.summaryBulletLabel {\n  font-weight: 700;\n  font-size: var(--font-size-label);\n}\n\n.chartSummaryItems {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.chartSummaryItem {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-weight: 700;\n}\n\n.chartSummaryDot {\n  width: 6px;\n  height: 6px;\n  border-radius: 999px;\n  background: currentColor;\n  margin-top: 7px;\n  flex-shrink: 0;\n}\n\n.rowBetween {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.rowWrap {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.correlationStatLabel {\n  font-size: var(--font-size-label);\n  text-transform: uppercase;\n  color: var(--color-text-muted);\n}\n\n.correlationStatRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n}\n\n.correlationStatValue {\n  font-size: var(--font-size-title);\n  font-weight: 600;\n  color: var(--color-text-strong);\n}\n\n.correlationStatInline {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 6px;\n}\n\n.correlationStatInlineLabel {\n  font-size: var(--font-size-label);\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n}\n\n.correlationStatInlineValue {\n  font-size: var(--font-size-label);\n  font-weight: 600;\n  color: var(--color-text-strong);\n}\n\n.correlationStatMeta {\n  font-size: var(--font-size-label);\n  color: var(--color-text-muted);\n}\n\n.correlationStatStrength {\n  font-size: var(--font-size-label);\n  color: var(--color-text-muted);\n}\n\n.correlationStatDivider {\n  color: var(--color-text-muted);\n  opacity: 0.6;\n}\n\n.correlationText {\n  font-size: var(--font-size-body);\n  color: var(--color-text-muted);\n}\n\n.correlationTextSmall {\n  font-size: var(--font-size-caption);\n  color: var(--color-text-muted);\n}\n\n.correlationHelpLinks {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.helpGuideCard {\n  padding: 12px;\n  border-radius: 12px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-panel);\n  color: var(--color-text-muted);\n  font-size: var(--font-size-body);\n  line-height: 1.5;\n}\n\n.helpGuideTitle {\n  font-weight: 600;\n  color: var(--color-text-strong);\n  margin-bottom: 8px;\n}\n\n.helpGuideSection {\n  margin-bottom: 10px;\n}\n\n.helpGuideHeading {\n  font-weight: 600;\n  color: var(--color-text-strong);\n  margin-bottom: 6px;\n}\n\n.helpGuideSubheading {\n  font-weight: 600;\n  color: var(--color-text);\n  margin: 6px 0 4px;\n}\n\n.helpGuideList {\n  margin: 6px 0 0;\n  padding-left: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.helpGuideQuote {\n  border-left: 2px solid var(--color-accent);\n  padding-left: 8px;\n  margin: 6px 0;\n  color: var(--color-text);\n}\n\n.helpGuideOverlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.helpGuideBackdrop {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.75);\n  backdrop-filter: blur(2px);\n}\n\n.helpGuideModal {\n  position: relative;\n  z-index: 1;\n  width: min(60vw, 760px);\n  color: var(--color-text);\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.45);\n}\n\n.helpGuideHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.helpGuideHeaderTitle {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.helpGuideClose {\n  border: none;\n  background: transparent;\n  color: var(--color-text-muted);\n  font-size: 1.2rem;\n  cursor: pointer;\n}\n\n.helpGuideBody {\n  max-height: min(70vh, 720px);\n  overflow: auto;\n}\n\n.helpGuideTabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.helpGuideTab {\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-muted);\n  color: var(--color-text-muted);\n  padding: 6px 12px;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.helpGuideTabActive {\n  background: var(--color-bg-panel);\n  color: var(--color-text-strong);\n}\n\n.helpGuidePlaceholder {\n  color: var(--color-text-muted);\n  font-size: 0.8rem;\n}\n\n.alertsPanel {\n  position: absolute;\n  top: 40px;\n  right: 10px;\n  width: 340px;\n  background: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  padding: 16px;\n  color: var(--color-text);\n  z-index: 100;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);\n}\n\n.alertsPanelHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 0.85rem;\n  font-weight: 600;\n  margin-bottom: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.alertsClose {\n  border: none;\n  background: transparent;\n  color: var(--color-text-muted);\n  font-size: 1.2rem;\n  cursor: pointer;\n  transition: color 0.2s;\n}\n\n.alertsClose:hover {\n  color: var(--color-text);\n}\n\n.alertsToggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.75rem;\n  color: var(--color-text-muted);\n  margin-bottom: 12px;\n}\n\n.alertsList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 260px;\n  overflow-y: auto;\n}\n\n.alertsItem {\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-muted);\n  border-radius: 10px;\n  padding: 10px 12px;\n  transition: border-color 0.2s;\n}\n\n.alertsItem:hover {\n  border-color: var(--color-text-muted);\n}\n\n.alertsItemHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.75rem;\n}\n\n.alertsItemBadges {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.alertModeBadge {\n  border: 1px solid var(--color-accent);\n  border-radius: 999px;\n  padding: 2px 8px;\n  font-size: 0.6rem;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: var(--color-accent);\n  background: rgba(99, 102, 241, 0.1);\n}\n\n.alertsItemLabel {\n  color: var(--color-text);\n  font-weight: 500;\n}\n\n.alertsSeverity {\n  text-transform: uppercase;\n  font-size: 0.65rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n}\n\n.alertSeverityInfo {\n  color: var(--color-accent);\n}\n\n.alertSeverityWarning {\n  color: #f59e0b;\n}\n\n.alertSeverityCritical {\n  color: #ef4444;\n}\n\n.alertsItemBody {\n  margin-top: 6px;\n  font-size: 0.75rem;\n  color: var(--color-text-muted);\n  line-height: 1.4;\n}\n\n.alertsItemTimestamp {\n  margin-top: 6px;\n  font-size: 0.65rem;\n  color: var(--color-text-muted);\n}\n\n/* Chart Panel */\n.chartPanel {\n  margin-top: 24px;\n  background: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  padding: 20px;\n}\n\n.chartHint {\n  color: var(--color-text-muted);\n  font-size: 0.8rem;\n  margin: 12px 0;\n}\n\n.chartControls {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.chartControlsRow {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 24px;\n  width: 100%;\n}\n\n.trendMenu {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n.trendMenuButton {\n  width: 32px;\n  height: 32px;\n  border-radius: 999px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-card);\n  color: var(--color-text);\n  font-size: 1.1rem;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s, border-color 0.2s;\n}\n\n.trendMenuButton:hover {\n  border-color: var(--color-accent);\n  background: var(--color-bg-muted);\n}\n\n.trendMenuPanel {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  width: 260px;\n  background: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 12px;\n  z-index: 100;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);\n}\n\n.trendMenuGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 10px;\n}\n\n.trendMenuGroup:last-child {\n  margin-bottom: 0;\n}\n\n.trendMenuTitle {\n  font-size: 0.65rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--color-text-muted);\n}\n\n.trendSelect {\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  color: var(--color-text);\n  border-radius: 8px;\n  padding: 6px 8px;\n  font-size: 0.75rem;\n}\n\n.trendSelect:focus {\n  outline: none;\n  border-color: var(--color-accent);\n}\n\n.trendToggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.7rem;\n  color: var(--color-text-muted);\n}\n\n.trendToggle input {\n  accent-color: var(--color-accent);\n}\n\n.chartWrapper {\n  background: var(--color-bg-muted);\n  border-radius: 12px;\n  border: 1px solid var(--color-border);\n  padding: 16px 12px 10px;\n  margin-top: 16px;\n}\n\n.trendChartWrapper {\n  position: relative;\n}\n\n.trendHelpIcon {\n  position: absolute;\n  top: 10px;\n  right: 12px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-card);\n  color: var(--color-accent);\n  font-size: 0.75rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: help;\n  z-index: 3;\n}\n\n.trendHelpTooltip {\n  position: absolute;\n  top: 26px;\n  right: 0;\n  width: 320px;\n  background: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 12px;\n  color: var(--color-text);\n  font-size: 0.75rem;\n  opacity: 0;\n  pointer-events: none;\n  transform: translateY(-4px);\n  transition: opacity 120ms ease-out, transform 120ms ease-out;\n  z-index: 10;\n  line-height: 1.4;\n  text-align: left;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.trendHelpTitle {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: var(--color-text);\n}\n\n.trendHelpItem {\n  display: block;\n  position: relative;\n  padding-left: 14px;\n  margin-bottom: 6px;\n  color: var(--color-text-muted);\n}\n\n.trendHelpItem::before {\n  content: '•';\n  position: absolute;\n  left: 0;\n  color: var(--color-accent);\n}\n\n.trendHelpIcon:hover .trendHelpTooltip,\n.trendHelpIcon:focus-visible .trendHelpTooltip {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.chartHelp {\n  font-size: 0.8rem;\n  color: var(--color-text-muted);\n  margin-top: 12px;\n}\n\n.columnName {\n  display: block;\n  font-size: 0.7rem;\n  font-weight: 500;\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.columnValue {\n  display: block;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--color-text);\n  margin-top: 4px;\n}\n\n/* TradingView Section */\n.tradingViewWrap {\n  margin-top: 20px;\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  background: var(--color-bg-card);\n  overflow: hidden;\n}\n\n.tradingViewChart {\n  width: 100%;\n  height: 360px;\n}\n\n/* Correlation Section */\n.correlationSection {\n  margin-top: 24px;\n  background: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  padding: 20px;\n}\n\n.correlationHeader {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.correlationHeaderLeft {\n  flex: 1 1 auto;\n}\n\n.correlationTitle {\n  font-size: var(--font-size-title);\n  font-weight: 600;\n  color: var(--color-text);\n  margin: 0;\n}\n\n.correlationSubtitle {\n  font-size: var(--font-size-caption);\n  color: var(--color-text-muted);\n  margin: 4px 0 0;\n}\n\n.correlationTourLink {\n  background: transparent;\n  border: none;\n  color: var(--color-accent);\n  font-size: var(--font-size-label);\n  cursor: pointer;\n  padding: 0;\n  white-space: nowrap;\n  text-decoration: underline;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.correlationTourLink:hover {\n  opacity: 0.8;\n}\n\n.correlationViewToggle {\n  background: transparent;\n  border: none;\n  color: var(--color-accent);\n  font-size: var(--font-size-caption);\n  cursor: pointer;\n  padding: 0;\n  text-decoration: underline;\n}\n\n.correlationHeaderLabel {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: var(--font-size-label);\n  color: var(--color-accent);\n}\n\n.correlationHeaderRight .correlationBadgeRow {\n  margin-top: 0;\n}\n\n.correlationMenuLabel {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.correlationInfoIcon {\n  position: relative;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-card);\n  color: var(--color-text-muted);\n  font-size: var(--font-size-tiny);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: help;\n}\n\n.correlationInfoTooltip {\n  position: absolute;\n  top: 24px;\n  left: 100%;\n  margin-left: 8px;\n  width: 280px;\n  padding: 12px;\n  border-radius: 12px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-card);\n  color: var(--color-text);\n  font-size: var(--font-size-caption);\n  line-height: 1.4;\n  opacity: 0;\n  pointer-events: none;\n  transform: translateY(-4px);\n  transition: opacity 120ms ease-out, transform 120ms ease-out;\n  z-index: 1000;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.correlationInfoTitle {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 6px;\n  color: var(--color-text);\n}\n\n.correlationInfoText {\n  display: block;\n  margin: 6px 0;\n  color: var(--color-text-muted);\n}\n\n.correlationInfoIcon:hover .correlationInfoTooltip,\n.correlationInfoIcon:focus-visible .correlationInfoTooltip {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.correlationControls {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px 12px;\n  font-size: var(--font-size-label);\n}\n\n.correlationLabelWithIcon {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.correlationSliderGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.correlationSliderRow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.correlationSliderRow input[type='range'] {\n  width: 140px;\n  accent-color: var(--color-accent);\n}\n\n.correlationLagValue {\n  font-size: var(--font-size-caption);\n  color: var(--color-text-muted);\n  min-width: 32px;\n  text-align: right;\n}\n\n.correlationSliderTicks {\n  display: flex;\n  justify-content: space-between;\n  width: 140px;\n  font-size: var(--font-size-tiny);\n  color: var(--color-accent);\n  padding-left: 2px;\n}\n\n.correlationTick {\n  position: relative;\n}\n\n.correlationTick::before {\n  content: '';\n  position: absolute;\n  top: -6px;\n  left: 50%;\n  width: 1px;\n  height: 6px;\n  background: var(--color-border);\n  transform: translateX(-50%);\n}\n\n.correlationSliderAnchors {\n  display: flex;\n  justify-content: space-between;\n  width: 140px;\n  font-size: var(--font-size-tiny);\n  color: var(--color-text-muted);\n}\n\n.correlationSummary {\n  margin-top: 16px;\n}\n\n.correlationValue {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  color: var(--color-text);\n  font-size: var(--font-size-body);\n}\n\n.correlationValue strong {\n  font-size: var(--font-size-section);\n}\n\n.correlationSample {\n  font-size: var(--font-size-caption);\n  color: var(--color-text-muted);\n}\n\n.correlationBadgeRow {\n  margin-top: 8px;\n}\n\n.correlationBadge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 12px;\n  border-radius: 999px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-muted);\n  font-size: 0.7rem;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n.correlationBadgeLow {\n  color: var(--color-text-muted);\n}\n\n.correlationBadgeModerate {\n  color: var(--color-text-muted);\n}\n\n.correlationBadgeHigh {\n  color: var(--color-accent);\n  border-color: var(--color-accent);\n  background: rgba(99, 102, 241, 0.1);\n}\n\n.correlationInterpretation {\n  margin-top: 6px;\n  font-size: 0.78rem;\n  color: var(--color-text-muted);\n}\n\n.correlationInterpretationText {\n  margin-top: 6px;\n  font-size: 0.75rem;\n  color: var(--color-text-muted);\n}\n\n.correlationHint {\n  margin-top: 6px;\n  font-size: 0.72rem;\n  color: var(--color-accent);\n}\n\n.correlationFootnote {\n  margin-top: 8px;\n  font-size: 0.7rem;\n  color: var(--color-accent);\n}\n\n.correlationWarning {\n  margin-top: 6px;\n  font-size: 0.72rem;\n  color: #f59e0b;\n}\n\n.correlationSparkline {\n  margin-top: 16px;\n  padding-top: 12px;\n  border-top: 1px solid var(--color-border);\n  cursor: pointer;\n}\n\n.correlationSparklineTitle {\n  font-size: 0.7rem;\n  color: var(--color-accent);\n  margin-bottom: 8px;\n}\n\n.correlationSparklineTooltip {\n  background: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  padding: 6px 10px;\n  border-radius: 8px;\n  color: var(--color-text);\n  font-size: 0.7rem;\n}\n\n.correlationMethodologyToggle {\n  margin-top: 12px;\n  background: transparent;\n  border: none;\n  color: var(--color-accent);\n  font-size: 0.75rem;\n  cursor: pointer;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  text-decoration: underline;\n}\n\n.correlationMethodologyChevron {\n  font-size: 0.75rem;\n  color: var(--color-accent);\n}\n\n.correlationMethodologyText {\n  margin-top: 10px;\n  max-width: 700px;\n  color: var(--color-text-muted);\n  font-size: 0.75rem;\n  line-height: 1.5;\n}\n\n.correlationFooterAnchor {\n  height: 1px;\n}\n\n/* Tour Anchors */\n.tourAnchorActive {\n  outline: 2px solid var(--color-accent);\n  outline-offset: 4px;\n  border-radius: 8px;\n}\n\n/* Positioning Tour Popover */\n.positioningTourPopover {\n  position: fixed;\n  width: 340px;\n  background: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  padding: 16px;\n  color: var(--color-text);\n  font-size: 0.75rem;\n  z-index: 1000;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);\n}\n\n.positioningTourHeading {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--color-text);\n  margin-bottom: 6px;\n}\n\n.positioningTourStep {\n  font-size: 0.7rem;\n  color: var(--color-accent);\n  margin-bottom: 8px;\n}\n\n.positioningTourTitle {\n  font-size: 0.85rem;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.positioningTourText {\n  margin: 6px 0;\n  color: var(--color-text-muted);\n  line-height: 1.4;\n}\n\n.positioningTourList {\n  margin: 6px 0;\n  padding-left: 20px;\n  color: var(--color-text-muted);\n}\n\n.positioningTourListItem {\n  margin-bottom: 6px;\n}\n\n.positioningTourExample {\n  margin-top: 10px;\n  color: var(--color-text-muted);\n}\n\n.positioningTourBold {\n  margin-top: 10px;\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.positioningTourActions {\n  margin-top: 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.positioningTourActionGroup {\n  display: inline-flex;\n  gap: 8px;\n}\n\n.positioningTourSkip {\n  background: transparent;\n  border: none;\n  color: var(--color-accent);\n  font-size: 0.75rem;\n  cursor: pointer;\n  padding: 0;\n  text-decoration: underline;\n}\n\n.positioningTourBack,\n.positioningTourNext {\n  background: var(--color-bg-muted);\n  border: 1px solid var(--color-border);\n  color: var(--color-text);\n  font-size: 0.75rem;\n  padding: 6px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: all 0.2s;\n}\n\n.positioningTourBack:hover,\n.positioningTourNext:hover {\n  border-color: var(--color-text-muted);\n}\n\n.positioningTourNext {\n  background: var(--color-accent);\n  border-color: var(--color-accent);\n  color: white;\n}\n\n.positioningTourBack:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n/* Signals Tour Popover */\n.signalsTourPopover {\n  position: fixed;\n  width: min(92vw, 420px);\n  background: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  padding: 16px 18px;\n  color: var(--color-text);\n  font-size: 0.75rem;\n  z-index: 1000;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);\n}\n\n.signalsTourHeading {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--color-text);\n  margin-bottom: 6px;\n}\n\n.signalsTourStep {\n  font-size: 0.7rem;\n  color: var(--color-accent);\n  margin-bottom: 10px;\n}\n\n.signalsTourTitle {\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.signalsTourBody {\n  color: var(--color-text-muted);\n  margin-bottom: 10px;\n  line-height: 1.4;\n}\n\n.signalsTourExample {\n  color: var(--color-text-muted);\n  margin-bottom: 10px;\n}\n\n.signalsTourSections {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.signalsTourSectionTitle {\n  font-weight: 600;\n  margin-bottom: 6px;\n  color: var(--color-text-muted);\n}\n\n.signalsTourSectionList {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.signalsTourSectionItem {\n  margin-bottom: 6px;\n  color: var(--color-text-muted);\n}\n\n.signalsTourBulletsTitle {\n  color: var(--color-text-muted);\n  margin-bottom: 6px;\n  font-weight: 600;\n}\n\n.signalsTourBullets {\n  margin: 6px 0 0;\n  padding-left: 20px;\n}\n\n.signalsTourBullet {\n  margin-bottom: 6px;\n  color: var(--color-text-muted);\n}\n\n.signalsTourClosing {\n  margin-top: 10px;\n  color: var(--color-text-muted);\n}\n\n.signalsTourFooter {\n  margin-top: 10px;\n  color: var(--color-accent);\n  font-weight: 600;\n}\n\n.signalsTourBold {\n  margin-top: 10px;\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.signalsTourActions {\n  margin-top: 14px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n}\n\n.signalsTourActionGroup {\n  display: inline-flex;\n  gap: 8px;\n}\n\n.signalsTourSkip {\n  background: transparent;\n  border: none;\n  color: var(--color-accent);\n  font-size: 0.75rem;\n  cursor: pointer;\n  padding: 0;\n  text-decoration: underline;\n}\n\n.signalsTourBack,\n.signalsTourNext,\n.signalsTourDone {\n  background: var(--color-bg-muted);\n  border: 1px solid var(--color-border);\n  color: var(--color-text);\n  font-size: 0.75rem;\n  padding: 6px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: all 0.2s;\n}\n\n.signalsTourBack:hover,\n.signalsTourNext:hover,\n.signalsTourDone:hover {\n  border-color: var(--color-text-muted);\n}\n\n.signalsTourNext,\n.signalsTourDone {\n  background: var(--color-accent);\n  border-color: var(--color-accent);\n  color: white;\n}\n\n.tourIcon {\n  font-size: 0.75rem;\n  display: inline-flex;\n}\n\n.signalsTourBack:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n/* Loading & Error States */\n.loadingState,\n.errorState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n}\n\n.loadingState {\n  color: var(--color-text-muted);\n}\n\n.errorState {\n  color: #ef4444;\n}\n\n.loadingSpinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid var(--color-border);\n  border-top-color: var(--color-accent);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 16px;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Empty State */\n.emptyState {\n  padding: 40px 20px;\n  text-align: center;\n  color: var(--color-text-muted);\n}\n\n.emptyStateIcon {\n  font-size: 3rem;\n  margin-bottom: 16px;\n  opacity: 0.5;\n}\n\n.emptyStateText {\n  font-size: 0.9rem;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .drawer {\n    padding: 16px;\n  }\n\n  .drawerHeader {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .summaryGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .detailList {\n    grid-template-columns: 1fr;\n  }\n\n  .correlationControls {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n/* Readiness Badge Styles */\n.readinessDefinitionList {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n}\n\n.readinessDefinitionItem {\n  display: block;\n  line-height: 1.5;\n}\n\n.readinessDefinition {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  margin-bottom: 0.75rem;\n}\n\n.readinessDefinitionTitle {\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n}\n.sparklesIcon {\n  color: var(--color-warning);\n  font-size: 1em;\n  flex-shrink: 0;\n}\n\n.helpGuideHeadingWithIcon {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.signalsTourHeading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"drawer": `SideDrawer_drawer__8TBjj`,
	"snapshotSummaryGrid": `SideDrawer_snapshotSummaryGrid__Ox2sQ`,
	"snapshotSummaryRowHalf": `SideDrawer_snapshotSummaryRowHalf__O6wZs`,
	"snapshotSummaryControls": `SideDrawer_snapshotSummaryControls__FwOdk`,
	"snapshotColumn": `SideDrawer_snapshotColumn__pZD2C`,
	"drawerHeader": `SideDrawer_drawerHeader__5-7-c`,
	"summaryColumn": `SideDrawer_summaryColumn__Xqkyj`,
	"summaryHeaderRow": `SideDrawer_summaryHeaderRow__7p3bC`,
	"sectionTitle": `SideDrawer_sectionTitle__co+zi`,
	"pillsRow": `SideDrawer_pillsRow__DKTLi`,
	"summaryColumnStack": `SideDrawer_summaryColumnStack__DceJj`,
	"snapshotCode": `SideDrawer_snapshotCode__04rzW`,
	"snapshotTicker": `SideDrawer_snapshotTicker__5JPSe`,
	"snapshotTickerRow": `SideDrawer_snapshotTickerRow__9Neq6`,
	"snapshotTickerLabel": `SideDrawer_snapshotTickerLabel__svSX1`,
	"snapshotTickerInput": `SideDrawer_snapshotTickerInput__TItQ+`,
	"snapshotTickerInline": `SideDrawer_snapshotTickerInline__ncTYn`,
	"snapshotTickerDisplay": `SideDrawer_snapshotTickerDisplay__9vMj8`,
	"snapshotTickerEditButton": `SideDrawer_snapshotTickerEditButton__cwmeh`,
	"drawerDate": `SideDrawer_drawerDate__KqZcj`,
	"recordSelect": `SideDrawer_recordSelect__Sxx1X`,
	"snapshotControls": `SideDrawer_snapshotControls__m1Pdl`,
	"snapshotRow": `SideDrawer_snapshotRow__cDgOd`,
	"snapshotRowTwo": `SideDrawer_snapshotRowTwo__et-Xp`,
	"snapshotRowThree": `SideDrawer_snapshotRowThree__nNIrI`,
	"snapshotColumnStack": `SideDrawer_snapshotColumnStack__ZS4Ok`,
	"selectFieldRow": `SideDrawer_selectFieldRow__-iYJH`,
	"selectField": `SideDrawer_selectField__QrdqI`,
	"reportDatePicker": `SideDrawer_reportDatePicker__8h4e7`,
	"inlineLabel": `SideDrawer_inlineLabel__zxixH`,
	"purchaserSelect": `SideDrawer_purchaserSelect__xhbnt`,
	"advancedDisclosure": `SideDrawer_advancedDisclosure__zKus2`,
	"advancedSummary": `SideDrawer_advancedSummary__ksqYK`,
	"advancedPanel": `SideDrawer_advancedPanel__i0kil`,
	"impactReportControls": `SideDrawer_impactReportControls__AevBt`,
	"tabList": `SideDrawer_tabList__iBjSH`,
	"tabButton": `SideDrawer_tabButton__rwjDB`,
	"tabButtonActive": `SideDrawer_tabButtonActive__j80jC`,
	"summaryGrid": `SideDrawer_summaryGrid__SXo0H`,
	"summaryCard": `SideDrawer_summaryCard__khKfG`,
	"detailList": `SideDrawer_detailList__wNb1N`,
	"detailItem": `SideDrawer_detailItem__kpg0r`,
	"columnsSection": `SideDrawer_columnsSection__p-Icb`,
	"columnsHeader": `SideDrawer_columnsHeader__rt4ds`,
	"columnGroups": `SideDrawer_columnGroups__dZDTq`,
	"columnGroup": `SideDrawer_columnGroup__XNRuD`,
	"purchaserTableWrap": `SideDrawer_purchaserTableWrap__77sCI`,
	"tableScroller": `SideDrawer_tableScroller__rpyy7`,
	"purchaserTable": `SideDrawer_purchaserTable__R-yhm`,
	"changeCell": `SideDrawer_changeCell__zkYXI`,
	"chartHeading": `SideDrawer_chartHeading__7eQsc`,
	"trendHeading": `SideDrawer_trendHeading__m74LF`,
	"trendHeadingLeft": `SideDrawer_trendHeadingLeft__dcD4W`,
	"trendViewLabel": `SideDrawer_trendViewLabel__ah4eZ`,
	"trendHeadingMeta": `SideDrawer_trendHeadingMeta__aMSkr`,
	"regimeBadgeGroup": `SideDrawer_regimeBadgeGroup__+EE7P`,
	"regimeBadge": `SideDrawer_regimeBadge__-iUpd`,
	"regimeTooltip": `SideDrawer_regimeTooltip__NPDTI`,
	"regimeTooltipList": `SideDrawer_regimeTooltipList__XY4s+`,
	"regimeTooltipItem": `SideDrawer_regimeTooltipItem__aMuqY`,
	"grossBadge": `SideDrawer_grossBadge__hldU4`,
	"grossBadgeElevated": `SideDrawer_grossBadgeElevated__Ls5kc`,
	"grossBadgeLow": `SideDrawer_grossBadgeLow__oi+1b`,
	"grossBadgeNormal": `SideDrawer_grossBadgeNormal__4gf8i`,
	"grossTooltip": `SideDrawer_grossTooltip__FsJem`,
	"grossTooltipLine": `SideDrawer_grossTooltipLine__K26o-`,
	"grossTooltipNote": `SideDrawer_grossTooltipNote__AQGVU`,
	"signalsTourLink": `SideDrawer_signalsTourLink__W7uoc`,
	"signalsTourLinkLeft": `SideDrawer_signalsTourLinkLeft__tq43I`,
	"regimeHelpIcon": `SideDrawer_regimeHelpIcon__jX7cA`,
	"regimeHelpTooltip": `SideDrawer_regimeHelpTooltip__wXuhl`,
	"regimeHelpTitle": `SideDrawer_regimeHelpTitle__P25oU`,
	"regimeHelpList": `SideDrawer_regimeHelpList__ql572`,
	"regimeHelpItem": `SideDrawer_regimeHelpItem__-H+1a`,
	"priceReferenceControl": `SideDrawer_priceReferenceControl__oXDQs`,
	"priceReferenceLabel": `SideDrawer_priceReferenceLabel__yW7Dg`,
	"priceReferenceInfoIcon": `SideDrawer_priceReferenceInfoIcon__sRsQv`,
	"priceReferenceTooltip": `SideDrawer_priceReferenceTooltip__fk+R2`,
	"priceReferenceSelect": `SideDrawer_priceReferenceSelect__cbUMR`,
	"readinessBadge": `SideDrawer_readinessBadge__B0k0z`,
	"readinessInfoIcon": `SideDrawer_readinessInfoIcon__PJGiq`,
	"readinessTooltip": `SideDrawer_readinessTooltip__wmwAl`,
	"readinessTooltipTitle": `SideDrawer_readinessTooltipTitle__Jpn6E`,
	"readinessTooltipRowGrid": `SideDrawer_readinessTooltipRowGrid__Do0Cz`,
	"readinessTooltipSection": `SideDrawer_readinessTooltipSection__n4yA9`,
	"readinessTooltipRow": `SideDrawer_readinessTooltipRow__RgbNQ`,
	"readinessTooltipLabel": `SideDrawer_readinessTooltipLabel__gWZLK`,
	"trendTooltip": `SideDrawer_trendTooltip__YgDao`,
	"trendTooltipLabel": `SideDrawer_trendTooltipLabel__Hp3oh`,
	"trendTooltipPrice": `SideDrawer_trendTooltipPrice__-FC8B`,
	"trendTooltipOi": `SideDrawer_trendTooltipOi__tVJ7Q`,
	"trendTooltipInsight": `SideDrawer_trendTooltipInsight__qh-Jc`,
	"trendTooltipDetails": `SideDrawer_trendTooltipDetails__xNEfD`,
	"trendRange": `SideDrawer_trendRange__nJo8o`,
	"cftcTooltipCard": `SideDrawer_cftcTooltipCard__ZrSxm`,
	"cftcTooltipHeader": `SideDrawer_cftcTooltipHeader__5h8ho`,
	"cftcTooltipTitle": `SideDrawer_cftcTooltipTitle__kEfJN`,
	"cftcTooltipBadge": `SideDrawer_cftcTooltipBadge__kfGvj`,
	"cftcTooltipMeta": `SideDrawer_cftcTooltipMeta__WjZ-z`,
	"cftcTooltipDesk": `SideDrawer_cftcTooltipDesk__dmRNp`,
	"cftcTooltipDeskLabel": `SideDrawer_cftcTooltipDeskLabel__8ikXC`,
	"cftcTooltipDeskBody": `SideDrawer_cftcTooltipDeskBody__Tu6eK`,
	"cftcTooltipActors": `SideDrawer_cftcTooltipActors__Cp1jl`,
	"cftcTooltipActor": `SideDrawer_cftcTooltipActor__eXCiy`,
	"cftcTooltipActorRow": `SideDrawer_cftcTooltipActorRow__Nji2Z`,
	"cftcTooltipActorLabel": `SideDrawer_cftcTooltipActorLabel__EgtMQ`,
	"cftcTooltipActorMeta": `SideDrawer_cftcTooltipActorMeta__ArPG0`,
	"cftcTooltipActorRight": `SideDrawer_cftcTooltipActorRight__ROcNr`,
	"cftcTooltipActorNet": `SideDrawer_cftcTooltipActorNet__qGLUw`,
	"alertsButton": `SideDrawer_alertsButton__K--e9`,
	"alertsCount": `SideDrawer_alertsCount__egqFQ`,
	"summaryMuted": `SideDrawer_summaryMuted__o2Ha0`,
	"summaryStrong": `SideDrawer_summaryStrong__MHoWx`,
	"summaryText": `SideDrawer_summaryText__iUp+E`,
	"summaryBanner": `SideDrawer_summaryBanner__2ewMQ`,
	"summaryWarning": `SideDrawer_summaryWarning__1JMes`,
	"panelCard": `SideDrawer_panelCard__ipLKI`,
	"panelTitle": `SideDrawer_panelTitle__tFRec`,
	"panelTitleSmall": `SideDrawer_panelTitleSmall__8zse8`,
	"panelBody": `SideDrawer_panelBody__gFt3O`,
	"impactReportGenerateCol": `SideDrawer_impactReportGenerateCol__NIDko`,
	"impactReportGenerateButton": `SideDrawer_impactReportGenerateButton__VD33n`,
	"impactReportGroupGrid": `SideDrawer_impactReportGroupGrid__kLcG8`,
	"impactReportGroupOption": `SideDrawer_impactReportGroupOption__KQtjW`,
	"impactReportSummary": `SideDrawer_impactReportSummary__bwmbs`,
	"impactReportSection": `SideDrawer_impactReportSection__ywj0x`,
	"impactReportList": `SideDrawer_impactReportList__tLbEo`,
	"impactRiskBadge": `SideDrawer_impactRiskBadge__vfRCI`,
	"impactRiskHigh": `SideDrawer_impactRiskHigh__Js5a1`,
	"impactRiskModerate": `SideDrawer_impactRiskModerate__07JQh`,
	"impactRiskLow": `SideDrawer_impactRiskLow__E1qZP`,
	"snapshotDonutWrap": `SideDrawer_snapshotDonutWrap__Zjk6i`,
	"snapshotDonutGrid": `SideDrawer_snapshotDonutGrid__RryEw`,
	"snapshotDonutCard": `SideDrawer_snapshotDonutCard__BZRG-`,
	"snapshotDonutLabel": `SideDrawer_snapshotDonutLabel__gECM2`,
	"snapshotChartHeader": `SideDrawer_snapshotChartHeader__Wu6k4`,
	"snapshotChartTitle": `SideDrawer_snapshotChartTitle__zEkTc`,
	"snapshotChangeCharts": `SideDrawer_snapshotChangeCharts__bOeZf`,
	"snapshotChangeGrid": `SideDrawer_snapshotChangeGrid__4XAm8`,
	"snapshotChangeCard": `SideDrawer_snapshotChangeCard__6S86m`,
	"snapshotChangeTitle": `SideDrawer_snapshotChangeTitle__lAGPV`,
	"snapshotPieWrap": `SideDrawer_snapshotPieWrap__xxfih`,
	"snapshotPieGrid": `SideDrawer_snapshotPieGrid__e3poe`,
	"snapshotPieCard": `SideDrawer_snapshotPieCard__3uDpW`,
	"snapshotPieRow": `SideDrawer_snapshotPieRow__SGagc`,
	"snapshotPieChart": `SideDrawer_snapshotPieChart__XtarR`,
	"snapshotPieStats": `SideDrawer_snapshotPieStats__xCv+I`,
	"snapshotPieStat": `SideDrawer_snapshotPieStat__0mBSJ`,
	"deskReadStack": `SideDrawer_deskReadStack__W9OPx`,
	"deskReadList": `SideDrawer_deskReadList__T-cFC`,
	"deskReadItem": `SideDrawer_deskReadItem__73xOz`,
	"deskReadBullet": `SideDrawer_deskReadBullet__hTH6O`,
	"summaryCardContent": `SideDrawer_summaryCardContent__hp-Wu`,
	"summaryCardCompact": `SideDrawer_summaryCardCompact__Efyj8`,
	"summaryRegimeRow": `SideDrawer_summaryRegimeRow__MoTuc`,
	"summaryNotesIndented": `SideDrawer_summaryNotesIndented__n6Wqu`,
	"summaryBulletList": `SideDrawer_summaryBulletList__3wNTU`,
	"summaryBulletItem": `SideDrawer_summaryBulletItem__bEaZT`,
	"summaryBulletDot": `SideDrawer_summaryBulletDot__jYbbM`,
	"summaryBulletLabel": `SideDrawer_summaryBulletLabel__tknaL`,
	"chartSummaryItems": `SideDrawer_chartSummaryItems__mtkon`,
	"chartSummaryItem": `SideDrawer_chartSummaryItem__2ZMGi`,
	"chartSummaryDot": `SideDrawer_chartSummaryDot__qUnaM`,
	"rowBetween": `SideDrawer_rowBetween__OfVzX`,
	"rowWrap": `SideDrawer_rowWrap__mxLU8`,
	"correlationStatLabel": `SideDrawer_correlationStatLabel__Xj4nU`,
	"correlationStatRow": `SideDrawer_correlationStatRow__6kEsD`,
	"correlationStatValue": `SideDrawer_correlationStatValue__zGeMY`,
	"correlationStatInline": `SideDrawer_correlationStatInline__-Rp95`,
	"correlationStatInlineLabel": `SideDrawer_correlationStatInlineLabel__vAkSK`,
	"correlationStatInlineValue": `SideDrawer_correlationStatInlineValue__5bV90`,
	"correlationStatMeta": `SideDrawer_correlationStatMeta__ipul6`,
	"correlationStatStrength": `SideDrawer_correlationStatStrength__fuXZ6`,
	"correlationStatDivider": `SideDrawer_correlationStatDivider__TJYuB`,
	"correlationText": `SideDrawer_correlationText__Th2TB`,
	"correlationTextSmall": `SideDrawer_correlationTextSmall__qtttH`,
	"correlationHelpLinks": `SideDrawer_correlationHelpLinks__erfj0`,
	"helpGuideCard": `SideDrawer_helpGuideCard__aVHrX`,
	"helpGuideTitle": `SideDrawer_helpGuideTitle__EFqM0`,
	"helpGuideSection": `SideDrawer_helpGuideSection__n5FqX`,
	"helpGuideHeading": `SideDrawer_helpGuideHeading__iliUV`,
	"helpGuideSubheading": `SideDrawer_helpGuideSubheading__eZRsG`,
	"helpGuideList": `SideDrawer_helpGuideList__eFF1s`,
	"helpGuideQuote": `SideDrawer_helpGuideQuote__GGZd2`,
	"helpGuideOverlay": `SideDrawer_helpGuideOverlay__iu2vM`,
	"helpGuideBackdrop": `SideDrawer_helpGuideBackdrop__u0qRw`,
	"helpGuideModal": `SideDrawer_helpGuideModal__8EaXI`,
	"helpGuideHeader": `SideDrawer_helpGuideHeader__o2z+6`,
	"helpGuideHeaderTitle": `SideDrawer_helpGuideHeaderTitle__vc4LI`,
	"helpGuideClose": `SideDrawer_helpGuideClose__V3Drj`,
	"helpGuideBody": `SideDrawer_helpGuideBody__rF9CV`,
	"helpGuideTabs": `SideDrawer_helpGuideTabs__ajuAu`,
	"helpGuideTab": `SideDrawer_helpGuideTab__kRfJT`,
	"helpGuideTabActive": `SideDrawer_helpGuideTabActive__w84Us`,
	"helpGuidePlaceholder": `SideDrawer_helpGuidePlaceholder__ErNUa`,
	"alertsPanel": `SideDrawer_alertsPanel__EsjIK`,
	"alertsPanelHeader": `SideDrawer_alertsPanelHeader__WHh-4`,
	"alertsClose": `SideDrawer_alertsClose__3Mrfm`,
	"alertsToggle": `SideDrawer_alertsToggle__AeqTW`,
	"alertsList": `SideDrawer_alertsList__Sk+ek`,
	"alertsItem": `SideDrawer_alertsItem__5IFwD`,
	"alertsItemHeader": `SideDrawer_alertsItemHeader__wdYzf`,
	"alertsItemBadges": `SideDrawer_alertsItemBadges__V8M9s`,
	"alertModeBadge": `SideDrawer_alertModeBadge__HkiFS`,
	"alertsItemLabel": `SideDrawer_alertsItemLabel__dlVCG`,
	"alertsSeverity": `SideDrawer_alertsSeverity__3Pp9m`,
	"alertSeverityInfo": `SideDrawer_alertSeverityInfo__L3xvN`,
	"alertSeverityWarning": `SideDrawer_alertSeverityWarning__tB6Uq`,
	"alertSeverityCritical": `SideDrawer_alertSeverityCritical__YJUAR`,
	"alertsItemBody": `SideDrawer_alertsItemBody__A-j3F`,
	"alertsItemTimestamp": `SideDrawer_alertsItemTimestamp__m0Eq9`,
	"chartPanel": `SideDrawer_chartPanel__gE8JE`,
	"chartHint": `SideDrawer_chartHint__8WSw4`,
	"chartControls": `SideDrawer_chartControls__bVwpS`,
	"chartControlsRow": `SideDrawer_chartControlsRow__B23kS`,
	"trendMenu": `SideDrawer_trendMenu__A6Coz`,
	"trendMenuButton": `SideDrawer_trendMenuButton__GNxdg`,
	"trendMenuPanel": `SideDrawer_trendMenuPanel__t3DAd`,
	"trendMenuGroup": `SideDrawer_trendMenuGroup__2VKje`,
	"trendMenuTitle": `SideDrawer_trendMenuTitle__fk09J`,
	"trendSelect": `SideDrawer_trendSelect__K2As0`,
	"trendToggle": `SideDrawer_trendToggle__KP1Pr`,
	"chartWrapper": `SideDrawer_chartWrapper__KUImj`,
	"trendChartWrapper": `SideDrawer_trendChartWrapper__wGySA`,
	"trendHelpIcon": `SideDrawer_trendHelpIcon__Z09zU`,
	"trendHelpTooltip": `SideDrawer_trendHelpTooltip__t3FX4`,
	"trendHelpTitle": `SideDrawer_trendHelpTitle__PMI7W`,
	"trendHelpItem": `SideDrawer_trendHelpItem__MlHOX`,
	"chartHelp": `SideDrawer_chartHelp__MG1x+`,
	"columnName": `SideDrawer_columnName__3sQ6p`,
	"columnValue": `SideDrawer_columnValue__vY2fd`,
	"tradingViewWrap": `SideDrawer_tradingViewWrap__1uIYM`,
	"tradingViewChart": `SideDrawer_tradingViewChart__sC5+S`,
	"correlationSection": `SideDrawer_correlationSection__5Q8EE`,
	"correlationHeader": `SideDrawer_correlationHeader__VGHOE`,
	"correlationHeaderLeft": `SideDrawer_correlationHeaderLeft__cUqmr`,
	"correlationTitle": `SideDrawer_correlationTitle__pdxTA`,
	"correlationSubtitle": `SideDrawer_correlationSubtitle__szVqB`,
	"correlationTourLink": `SideDrawer_correlationTourLink__GQrvr`,
	"correlationViewToggle": `SideDrawer_correlationViewToggle__Tu+9K`,
	"correlationHeaderLabel": `SideDrawer_correlationHeaderLabel__NTArm`,
	"correlationHeaderRight": `SideDrawer_correlationHeaderRight__2Ie-D`,
	"correlationBadgeRow": `SideDrawer_correlationBadgeRow__bMxOT`,
	"correlationMenuLabel": `SideDrawer_correlationMenuLabel__rl2Cj`,
	"correlationInfoIcon": `SideDrawer_correlationInfoIcon__8KrCm`,
	"correlationInfoTooltip": `SideDrawer_correlationInfoTooltip__IDnMV`,
	"correlationInfoTitle": `SideDrawer_correlationInfoTitle__RX3LS`,
	"correlationInfoText": `SideDrawer_correlationInfoText__5ce9R`,
	"correlationControls": `SideDrawer_correlationControls__icafP`,
	"correlationLabelWithIcon": `SideDrawer_correlationLabelWithIcon__8Hw+T`,
	"correlationSliderGroup": `SideDrawer_correlationSliderGroup__B44w4`,
	"correlationSliderRow": `SideDrawer_correlationSliderRow__0mKIa`,
	"correlationLagValue": `SideDrawer_correlationLagValue__69EIU`,
	"correlationSliderTicks": `SideDrawer_correlationSliderTicks__tSGsh`,
	"correlationTick": `SideDrawer_correlationTick__O1IDf`,
	"correlationSliderAnchors": `SideDrawer_correlationSliderAnchors__FE85W`,
	"correlationSummary": `SideDrawer_correlationSummary__NhO6N`,
	"correlationValue": `SideDrawer_correlationValue__GfLBK`,
	"correlationSample": `SideDrawer_correlationSample__6+gcA`,
	"correlationBadge": `SideDrawer_correlationBadge__98MBM`,
	"correlationBadgeLow": `SideDrawer_correlationBadgeLow__UNKod`,
	"correlationBadgeModerate": `SideDrawer_correlationBadgeModerate__FLd5c`,
	"correlationBadgeHigh": `SideDrawer_correlationBadgeHigh__5lHj-`,
	"correlationInterpretation": `SideDrawer_correlationInterpretation__XXoQP`,
	"correlationInterpretationText": `SideDrawer_correlationInterpretationText__sNTkQ`,
	"correlationHint": `SideDrawer_correlationHint__ZVMPq`,
	"correlationFootnote": `SideDrawer_correlationFootnote__xALhf`,
	"correlationWarning": `SideDrawer_correlationWarning__0iZE7`,
	"correlationSparkline": `SideDrawer_correlationSparkline__kPVdK`,
	"correlationSparklineTitle": `SideDrawer_correlationSparklineTitle__1We3o`,
	"correlationSparklineTooltip": `SideDrawer_correlationSparklineTooltip__7ty7H`,
	"correlationMethodologyToggle": `SideDrawer_correlationMethodologyToggle__2nx9K`,
	"correlationMethodologyChevron": `SideDrawer_correlationMethodologyChevron__mBK8s`,
	"correlationMethodologyText": `SideDrawer_correlationMethodologyText__Po1dj`,
	"correlationFooterAnchor": `SideDrawer_correlationFooterAnchor__edAPz`,
	"tourAnchorActive": `SideDrawer_tourAnchorActive__tZwby`,
	"positioningTourPopover": `SideDrawer_positioningTourPopover__MyRe1`,
	"positioningTourHeading": `SideDrawer_positioningTourHeading__O0CsR`,
	"positioningTourStep": `SideDrawer_positioningTourStep__mQJFS`,
	"positioningTourTitle": `SideDrawer_positioningTourTitle__TkYHa`,
	"positioningTourText": `SideDrawer_positioningTourText__lx-+8`,
	"positioningTourList": `SideDrawer_positioningTourList__Aio2-`,
	"positioningTourListItem": `SideDrawer_positioningTourListItem__OTx8l`,
	"positioningTourExample": `SideDrawer_positioningTourExample__GqAU0`,
	"positioningTourBold": `SideDrawer_positioningTourBold__t1G6N`,
	"positioningTourActions": `SideDrawer_positioningTourActions__lsBM7`,
	"positioningTourActionGroup": `SideDrawer_positioningTourActionGroup__nL+3V`,
	"positioningTourSkip": `SideDrawer_positioningTourSkip__OyyFz`,
	"positioningTourBack": `SideDrawer_positioningTourBack__tSCsF`,
	"positioningTourNext": `SideDrawer_positioningTourNext__YGEdu`,
	"signalsTourPopover": `SideDrawer_signalsTourPopover__n4v6a`,
	"signalsTourHeading": `SideDrawer_signalsTourHeading__rwYfW`,
	"signalsTourStep": `SideDrawer_signalsTourStep__A3VxO`,
	"signalsTourTitle": `SideDrawer_signalsTourTitle__M7x5W`,
	"signalsTourBody": `SideDrawer_signalsTourBody__I2Z3x`,
	"signalsTourExample": `SideDrawer_signalsTourExample__x0EfT`,
	"signalsTourSections": `SideDrawer_signalsTourSections__oR7ta`,
	"signalsTourSectionTitle": `SideDrawer_signalsTourSectionTitle__sqCpv`,
	"signalsTourSectionList": `SideDrawer_signalsTourSectionList__G9pBI`,
	"signalsTourSectionItem": `SideDrawer_signalsTourSectionItem__QMhf+`,
	"signalsTourBulletsTitle": `SideDrawer_signalsTourBulletsTitle__zl6VG`,
	"signalsTourBullets": `SideDrawer_signalsTourBullets__cqNJp`,
	"signalsTourBullet": `SideDrawer_signalsTourBullet__-nNON`,
	"signalsTourClosing": `SideDrawer_signalsTourClosing__bbM+S`,
	"signalsTourFooter": `SideDrawer_signalsTourFooter__ZxOAk`,
	"signalsTourBold": `SideDrawer_signalsTourBold__n7czE`,
	"signalsTourActions": `SideDrawer_signalsTourActions__jTGC+`,
	"signalsTourActionGroup": `SideDrawer_signalsTourActionGroup__r-QH3`,
	"signalsTourSkip": `SideDrawer_signalsTourSkip__2PgmG`,
	"signalsTourBack": `SideDrawer_signalsTourBack__poy1v`,
	"signalsTourNext": `SideDrawer_signalsTourNext__0cafc`,
	"signalsTourDone": `SideDrawer_signalsTourDone__n68Vk`,
	"tourIcon": `SideDrawer_tourIcon__n0pbZ`,
	"loadingState": `SideDrawer_loadingState__rbw0k`,
	"errorState": `SideDrawer_errorState__0y3Hn`,
	"loadingSpinner": `SideDrawer_loadingSpinner__SxnZ+`,
	"spin": `SideDrawer_spin__zJSrE`,
	"emptyState": `SideDrawer_emptyState__VFiDv`,
	"emptyStateIcon": `SideDrawer_emptyStateIcon__cTKrl`,
	"emptyStateText": `SideDrawer_emptyStateText__INeuL`,
	"readinessDefinitionList": `SideDrawer_readinessDefinitionList__i1fuV`,
	"readinessDefinitionItem": `SideDrawer_readinessDefinitionItem__vz1nd`,
	"readinessDefinition": `SideDrawer_readinessDefinition__JCLf5`,
	"readinessDefinitionTitle": `SideDrawer_readinessDefinitionTitle__fKWKB`,
	"sparklesIcon": `SideDrawer_sparklesIcon__uPKsE`,
	"helpGuideHeadingWithIcon": `SideDrawer_helpGuideHeadingWithIcon__Cm8T-`
};
export default ___CSS_LOADER_EXPORT___;
